import React, { useContext, useEffect, useState, useMemo } from "react";
import { Layout, Menu, Typography, Drawer, Button, Modal, Card, Badge, message, Input, Statistic, Row, Col, Progress, Tag, Segmented, Avatar } from "antd";
import dayjs from "dayjs";
import {
  HomeOutlined,
  FileAddOutlined,
  FileTextOutlined,
  TeamOutlined,
  UserSwitchOutlined,
  CalendarOutlined,
  CalendarFilled,
  ClockCircleOutlined,
  CheckCircleOutlined,
  SolutionOutlined,
  FileDoneOutlined,
  AuditOutlined,
  RiseOutlined,
  AlertOutlined,
  LogoutOutlined,
  HistoryOutlined,
  FormOutlined,
  MenuOutlined,
  EditOutlined,
  MoreOutlined,
  HourglassOutlined,
  WalletOutlined,
  UserOutlined,
  ScheduleOutlined,
  FileProtectOutlined,
  InboxOutlined,
  FieldBinaryOutlined,
  SyncOutlined,
  BarChartOutlined,
  SearchOutlined
} from "@ant-design/icons";
import { AuthContext } from "../../context/AuthContext";
import { PieChart, Pie, Cell, Tooltip as RechartsTooltip, ResponsiveContainer } from "recharts";
import { useNavigation } from "../../context/NavigationContext";
import DashboardHeader from "../../components/dashboardheader/DashboardHeader";
import Footer from "../../components/footer/Footer";
import CreateMrf from "../createmrf/CreateMrf";
import HodViewReq from "../hod_viewreq/HodViewReq";
import InterviewPage from "../interviewpage/InterviewPage";
import ViewTeam from "../hod/ViewTeam";
import ViewAnnouncement from "../../components/employee/ViewAnnouncement";
import Teamleaves from "../../components/Teamleaves";
import TeamCompoff from "../../components/employee/TeamCompoff";
import TeamPermissions from "../../components/TeamPermissions";
import OffDay from "../../components/employee/OffDay";
import Permission from "../../components/employee/Permission";
import Leaves from "../../components/employee/Leaves";
import Holidays from "../employee/Holidays";
import TeamAttendance from "../../components/TeamAttendance";
import ViewEmpAttendance from "../../components/attendance/viewEmpAttendance";
import Rfc from "../../components/Rfc";
import ProbationReview from "../../components/employee/ProbationReview";
import WeddingGreetings from "../../components/WeddingGreetings";
import OtApprovals from "../../components/OtApprovals";
import TeamAssessment from "../TeamAssessment";
import PipApprovals from "../PipApprovals";
import ResignationRequests from "../ResignationRequests";
import LeaveCalendar from "../../components/employee/LeaveCalendar";
import ViewBirthDay from "../../components/ViewBirthDay";
import ImproperLog from "../../components/ImproperLog";
import WorkCard from "../../components/WorkCard";
import axios from "axios";
import Welcome from "../../components/Welcome";
import OverallEmployees from "../../components/employee/OverallEmployees"
import InduvidualAttendance from "../employee/InduvidualAttendance";
import EmployeeProfile from "../EmployeeProfile";
import NotificationBar from "../NotificationBar";
import SignatureUpdation from "../payroll/SignatureUpdation";
import OrgChart from "../OrgChart";
import { motion } from "framer-motion";
import { Sparkles, ShieldCheck, Zap, Calendar as LucideCalendar, User as LucideUser, Clock as LucideClock, FileText, Wallet as LucideWallet, Users, Award } from "lucide-react";
import UserImg from "../../assests/user_avatar.png";
import PastOnduty from "../employee/PastOnduty";
import Resignation from "../Resignation";
import ListNoc from "../ListNoc";
import ExitInterview from "../ExitInterview";
import TeamMembers from "../hod/TeamMembers";
import OnDutyAttendance from "../../components/OndutyAttendance";
import AppliedOnduty from "../employee/AppliedOnDuty"
import PaySlip from "../../components/PaySlip";
import NoticeEmployees from "../../components/employee/NoticeEmployees";

const getLeaveColorAndBadge = (member) => {
  if (!member) return { color: "#64748b", bg: "#f8fafc", border: "#e2e8f0", text: "#475569", icon: "ℹ️", label: "-", tagColor: "default" };

  const lType = (member.leave_type || member.LeaveType || "").toUpperCase();
  const statusStr = (member.status || member.AttendanceStatus || member.Status || "").toUpperCase();
  const remarksStr = (member.StatusMessage || member.remarks || "").toUpperCase();
  const durType = (member.duration_type || member.DurationType || "").toUpperCase();

  const isHalfDay = lType.includes("HALF") || remarksStr.includes("HALF") || statusStr.includes("HALF") || durType.includes("HALF");

  if (statusStr.includes("LATE") || remarksStr.includes("LATE") || member.is_late) {
    return { color: "#d97706", bg: "#fffbeb", border: "#fde68a", text: "#d97706", icon: "⏰", label: "Late In", tagColor: "gold" };
  }

  // ── HALF DAY VARIANTS (Must be evaluated BEFORE full-day leaves) ──
  if (isHalfDay) {
    if (lType.includes("SICK") || remarksStr.includes("SICK") || lType === "SL") {
      return { color: "#B1A1C8", bg: "#f3e8ff", border: "#e9d5ff", text: "#6b21a8", icon: "🌸", label: "Half Day Sick", tagColor: "purple" };
    }
    if (lType.includes("CASUAL") || remarksStr.includes("CASUAL") || lType === "CL") {
      return { color: "#FE66CB", bg: "#fdf2f8", border: "#fbcfe8", text: "#9d174d", icon: "🎀", label: "Half Day Casual", tagColor: "pink" };
    }
    if (lType.includes("WEEK") || remarksStr.includes("WEEK") || statusStr.includes("WEEK") || lType === "WO" || lType === "WEEKOFF") {
      return { color: "#ffcc00", bg: "#fffbebe6", border: "#fde68a", text: "#92400e", icon: "🌴", label: "Half Day Week Off", tagColor: "warning" };
    }
    if (lType.includes("COMP") || remarksStr.includes("COMP") || lType === "CO") {
      return { color: "#66ffff", bg: "#ecfeff", border: "#a5f3fc", text: "#0891b2", icon: "⚡", label: "Half Day Comp Off", tagColor: "cyan" };
    }
    return { color: "#FE66CB", bg: "#fdf2f8", border: "#fbcfe8", text: "#FE66CB", icon: "🎀", label: member.leave_type || member.LeaveType || "Half Day Leave", tagColor: "pink" };
  }

  // ── FULL DAY LEAVES ──
  if (lType.includes("CASUAL") || remarksStr.includes("CASUAL") || lType === "CL") {
    return { color: "#CB00CC", bg: "#f3e8ff", border: "#d8b4fe", text: "#CB00CC", icon: "🟣", label: member.leave_type || member.LeaveType || "Casual Leave", tagColor: "purple" };
  }
  if (lType.includes("SICK") || remarksStr.includes("SICK") || lType === "SL") {
    return { color: "#FF0066", bg: "#fce7f3", border: "#fbcfe8", text: "#FF0066", icon: "🌸", label: member.leave_type || member.LeaveType || "Sick Leave", tagColor: "magenta" };
  }
  if (lType.includes("EARNED") || remarksStr.includes("EARNED") || lType === "EL") {
    return { color: "#2563eb", bg: "#dbeafe", border: "#bfdbfe", text: "#2563eb", icon: "🔷", label: member.leave_type || member.LeaveType || "Earned Leave", tagColor: "blue" };
  }
  if (lType.includes("LOP") || lType.includes("LOSS OF PAY") || remarksStr.includes("LOP") || lType === "NLB") {
    return { color: "#bf4406", bg: "#ffedd5", border: "#fed7aa", text: "#bf4406", icon: "🟧", label: member.leave_type || member.LeaveType || "Loss of Pay (LOP)", tagColor: "volcano" };
  }
  if (lType.includes("WEEK") || lType.includes("SUNDAY") || lType.includes("OFF DAY") || lType === "WO" || lType === "WEEKOFF" || remarksStr.includes("WEEK OFF") || statusStr === "SUNDAY") {
    return { color: "#eab308", bg: "#fefce8", border: "#fef08a", text: "#a16207", icon: "🌴", label: statusStr.includes("SUNDAY") ? "Sunday" : "Week Off", tagColor: "gold" };
  }
  if (lType.includes("COMP") || lType === "CO" || remarksStr.includes("COMP OFF")) {
    return { color: "#1FA2CC", bg: "#e0f2fe", border: "#bae6fd", text: "#1FA2CC", icon: "⚡", label: "Comp Off", tagColor: "cyan" };
  }
  if (lType.includes("HOLIDAY") || remarksStr.includes("HOLIDAY")) {
    return { color: "#F79647", bg: "#fff7ed", border: "#fed7aa", text: "#F79647", icon: "🎉", label: member.HolidayName || "Holiday", tagColor: "orange" };
  }
  if (lType.includes("PERMISSION") || remarksStr.includes("PERMISSION") || statusStr.includes("PERMISSION") || member.permission_type) {
    return { color: "#2563eb", bg: "#eff6ff", border: "#bfdbfe", text: "#1d4ed8", icon: "⏱️", label: member.permission_type || "Permission", tagColor: "blue" };
  }
  if (statusStr.includes("ONDUTY") || member.onduty_type) {
    return { color: "#8b5cf6", bg: "#f5f3ff", border: "#ddd6fe", text: "#5b21b6", icon: "💼", label: member.onduty_type || "On Duty", tagColor: "purple" };
  }
  if (statusStr.includes("PRESENT") || member.check_in_time) {
    return { color: "#10B981", bg: "#f0fdf4", border: "#bbf7d0", text: "#10B981", icon: "🟢", label: "Present", tagColor: "green" };
  }

  // Pure unplanned absent (no leave type)
  if (lType === "-" || lType === "" || lType === "ABSENT") {
    return { color: "#F43F5E", bg: "#fef2f2", border: "#fecaca", text: "#F43F5E", icon: "🔴", label: "Absent", tagColor: "red" };
  }

  return { color: "#CB00CC", bg: "#fdf2f8", border: "#fbcfe8", text: "#CB00CC", icon: "🏖️", label: member.leave_type || member.LeaveType || member.status || "On Leave", tagColor: "purple" };
};

const getMemberDisplayTime = (member) => {
  if (!member) return "-";
  if (member.check_in_time) return member.check_in_time;
  if (member.check_in_raw) return member.check_in_raw;
  if (member.check_in) return member.check_in;
  if (member.first_check_in) return member.first_check_in;
  if (member.time) return member.time;
  if (member.hours_requested) return `${member.hours_requested} hrs`;
  return "-";
};

const { Sider, Content } = Layout;
const { Title } = Typography;
const { TextArea } = Input

export default function Hoddashboard() {
  const { authData, backUrl } = useContext(AuthContext);
  const { registerNavigator } = useNavigation();

  const [selectedMenu, setSelectedMenu] = useState(
    localStorage.getItem("hodDashboardPage") || "home"
  );

  // Register this dashboard's menu setter so NotificationBar can navigate into it
  useEffect(() => {
    const cleanup = registerNavigator((menuKey) => setSelectedMenu(menuKey));
    return cleanup;
  }, [registerNavigator]);
  const [showProfile, setShowProfile] = useState(false)
  const [isHovered, setIsHovered] = useState(false);

  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // ────── NEW STATE FOR HOME PAGE (copied from EmployeeDashboard) ──────
  const [showWishes, setShowWishes] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true);
  const [celebrations, setCelebrations] = useState({ birthdays: [], work_anniversaries: [] });
  const [eventsModalVisible, setEventsModalVisible] = useState(false);
  const [mywishes, setMyWishes] = useState([]);
  const [wishesModalVisible, setWishesModalVisible] = useState(false);
  const [wishesSearchQuery, setWishesSearchQuery] = useState("");
  const [wishModalVisible, setWishModalVisible] = useState(false);
  const [wishMessage, setWishMessage] = useState("");
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [logModalVisible, setLogModalVisible] = useState(false);
  const [selectedLogMember, setSelectedLogMember] = useState(null);

  useEffect(() => {
    localStorage.setItem("hodDashboardPage", selectedMenu);
  }, [selectedMenu]);

  useEffect(() => {
    const welcomeShown = localStorage.getItem("welcomeShown");
    if (welcomeShown) {
      setShowWelcome(true);
      setTimeout(() => {
        localStorage.setItem("welcomeShown", "false");
        setShowWelcome(false);
      }, 3000);
    }
  }, []);

  // Responsive handling
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ────── FETCH CELEBRATIONS & MY WISHES (same as EmployeeDashboard) ──────
  const fetchWishes = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/probation/celebrations/today/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setCelebrations(res.data);
    } catch (error) {
      console.error("Error fetching celebrations:", error);
    }
  };

  const fetchMyWishes = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/probation/celebrations/my/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setMyWishes(res.data);
    } catch (error) {
      console.error("Error fetching my wishes:", error);
    }
  };

  useEffect(() => {
    fetchWishes();
    fetchMyWishes();
  }, [authData, backUrl]);
  // ─────────────────────────────────────────────────────────────────────

  const [dashboardMode, setDashboardMode] = useState("self");
  const [activeTeamTab, setActiveTeamTab] = useState("present");
  const [checkData, setCheckData] = useState({ team_count: 0 });
  const [teamAttendanceData, setTeamAttendanceData] = useState(null);
  const [teamPendingData, setTeamPendingData] = useState(null);
  const [memberCategoryModal, setMemberCategoryModal] = useState({ visible: false, title: "", members: [], color: "" });
  const [searchModalQuery, setSearchModalQuery] = useState("");
  const [pendingRequestsModal, setPendingRequestsModal] = useState(false);
  const [hoveredDonutSlice, setHoveredDonutSlice] = useState(null);

  const checkEmployeeAccess = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/emp/my-team/count/`, {
        headers: { Authorization: `Bearer ${authData?.access}` }
      });
      setCheckData(res.data);
    } catch (err) {
      console.error("Error checking team count:", err);
    }
  };

  const fetchTeamTodayAttendance = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/emp/my-team/attendance-today/`, {
        headers: { Authorization: `Bearer ${authData?.access}` }
      });
      setTeamAttendanceData(res.data);
    } catch (err) {
      console.error("Error fetching team today attendance:", err);
    }
  };

  const fetchTeamPendingRequests = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/emp/my-team/pending-requests/`, {
        headers: { Authorization: `Bearer ${authData?.access}` }
      });
      setTeamPendingData(res.data);
    } catch (err) {
      console.error("Error fetching team pending requests:", err);
    }
  };

  useEffect(() => {
    if (dashboardMode === "team") {
      fetchTeamTodayAttendance();
      fetchTeamPendingRequests();
    }
  }, [dashboardMode]);

  useEffect(() => {
    checkEmployeeAccess();
  }, []);

  const [leaveDetails, setLeaveDetails] = useState(null);

  const getLeaveSummary = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/hr/leave-summary/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setLeaveDetails(res.data);
    }
    catch (error) {
      console.error("Error fetching leaves:", error);

    }
  }

  useEffect(() => {
    getLeaveSummary();
  }, []);

  const [isSendingWish, setIsSendingWish] = useState(false);

  const handleSendWish = async () => {
    if (!wishMessage?.trim()) {
      message.warning("Please enter your wish before sending 🎉");
      return;
    }
    setIsSendingWish(true);
    try {
      const payload = {
        receiver_id: selectedPerson?.id ?? 0,
        occasion: "BIRTHDAY",
        message: wishMessage,
      };
      await axios.post(`${backUrl}/api/probation/celebrations/send/`, payload, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      message.success(`Wish sent successfully!`);
      setWishModalVisible(false);
      setWishMessage("");
      fetchMyWishes(); // refresh my wishes
    } catch (error) {
      console.error("Error sending wish:", error);
      message.error("Failed to send wish. Try again later.");
    } finally {
      setIsSendingWish(false);
    }
  };

  const LeaveSummary = ({ data }) => {
    const { allotments, balances, totals } = data;

    const clTotal = allotments?.CL || 0;
    const clTaken = totals?.CL_Taken || 0;
    const clBal = balances?.CL || 0;

    const slTotal = allotments?.SL || 0;
    const slTaken = totals?.SL_Taken || 0;
    const slBal = balances?.SL || 0;

    const compoffTotal = allotments?.Compoff || 0;
    const compoffTaken = totals?.Compoff_Taken || 0;
    const compoffBal = balances?.Compoff || 0;

    const weekoffTotal = allotments?.WeekOff || 0;
    const weekoffTaken = totals?.WeekOff_Taken || 0;
    const weekoffBal = balances?.WeekOff || 0;

    const compWeekTotal = compoffTotal + weekoffTotal;
    const compWeekBalTotal = compoffBal + weekoffBal;

    const clPct = clTotal > 0 ? Math.min(100, Math.round((clBal / clTotal) * 100)) : 0;
    const slPct = slTotal > 0 ? Math.min(100, Math.round((slBal / slTotal) * 100)) : 0;
    const compWeekPct = compWeekTotal > 0 ? Math.min(100, Math.round((compWeekBalTotal / compWeekTotal) * 100)) : 0;

    return (
      <div style={{ width: "100%" }} className="mb-4">
        <Card
          title={
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  background: "linear-gradient(135deg, #0e497b, #2563eb)",
                  color: "#ffffff",
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 16,
                  boxShadow: "0 3px 10px rgba(14,73,123,0.25)",
                }}
              >
                📊
              </div>
              <span style={{ fontWeight: 800, color: "#0e497b", fontSize: 17, letterSpacing: "-0.2px" }}>
                Leave Entitlements & Balances
              </span>
            </div>
          }
          bordered={false}
          style={{
            borderRadius: 20,
            border: "1px solid #e2e8f0",
            boxShadow: "0 4px 24px rgba(15,23,42,0.05)",
            background: "#ffffff",
          }}
          bodyStyle={{ padding: "24px" }}
        >
          <Row gutter={[24, 24]}>
            {/* GAUGECARD 1: CASUAL LEAVE (CL) */}
            <Col xs={24} md={8}>
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: 16,
                  border: "1px solid #e2e8f0",
                  padding: "20px 16px",
                  textAlign: "center",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <div>
                  <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
                    <div
                      style={{
                        background: "linear-gradient(135deg, #059669, #10b981)",
                        color: "#fff",
                        width: 30,
                        height: 30,
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 15,
                        boxShadow: "0 2px 6px rgba(5,150,105,0.2)",
                      }}
                    >
                      🏖️
                    </div>
                    <span style={{ fontWeight: 800, fontSize: 15, color: "#0f172a" }}>
                      Casual Leave (CL)
                    </span>
                  </div>

                  <div className="my-2">
                    <Progress
                      type="dashboard"
                      percent={clPct}
                      width={120}
                      strokeColor={{ "0%": "#10b981", "100%": "#059669" }}
                      trailColor="#e2e8f0"
                      strokeWidth={9}
                      format={() => (
                        <div style={{ marginTop: "-2px" }}>
                          <div style={{ fontSize: 24, fontWeight: 900, color: "#059669" }}>{clBal}</div>
                          <div style={{ fontSize: 10.5, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>Days Left</div>
                        </div>
                      )}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between gap-2 mt-3 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Allotted</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#0e497b" }}>{clTotal} Days</div>
                  </div>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Taken</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#d97706" }}>{clTaken} Days</div>
                  </div>
                </div>
              </div>
            </Col>

            {/* GAUGECARD 2: SICK LEAVE (SL) */}
            <Col xs={24} md={8}>
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: 16,
                  border: "1px solid #e2e8f0",
                  padding: "20px 16px",
                  textAlign: "center",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <div>
                  <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
                    <div
                      style={{
                        background: "linear-gradient(135deg, #2563eb, #3b82f6)",
                        color: "#fff",
                        width: 30,
                        height: 30,
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 15,
                        boxShadow: "0 2px 6px rgba(37,99,235,0.2)",
                      }}
                    >
                      🤒
                    </div>
                    <span style={{ fontWeight: 800, fontSize: 15, color: "#0f172a" }}>
                      Sick Leave (SL)
                    </span>
                  </div>

                  <div className="my-2">
                    <Progress
                      type="dashboard"
                      percent={slPct}
                      width={120}
                      strokeColor={{ "0%": "#3b82f6", "100%": "#1d4ed8" }}
                      trailColor="#e2e8f0"
                      strokeWidth={9}
                      format={() => (
                        <div style={{ marginTop: "-2px" }}>
                          <div style={{ fontSize: 24, fontWeight: 900, color: "#2563eb" }}>{slBal}</div>
                          <div style={{ fontSize: 10.5, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>Days Left</div>
                        </div>
                      )}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between gap-2 mt-3 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Allotted</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#0e497b" }}>{slTotal} Days</div>
                  </div>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Taken</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#d97706" }}>{slTaken} Days</div>
                  </div>
                </div>
              </div>
            </Col>

            {/* GAUGECARD 3: COMP / WEEK OFF */}
            <Col xs={24} md={8}>
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: 16,
                  border: "1px solid #e2e8f0",
                  padding: "20px 16px",
                  textAlign: "center",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <div>
                  <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
                    <div
                      style={{
                        background: "linear-gradient(135deg, #7c3aed, #a855f7)",
                        color: "#fff",
                        width: 30,
                        height: 30,
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 15,
                        boxShadow: "0 2px 6px rgba(124,58,237,0.2)",
                      }}
                    >
                      🛌
                    </div>
                    <span style={{ fontWeight: 800, fontSize: 15, color: "#0f172a" }}>
                      Comp / Week Off
                    </span>
                  </div>

                  <div className="my-2">
                    <Progress
                      type="dashboard"
                      percent={compWeekPct}
                      width={120}
                      strokeColor={{ "0%": "#a855f7", "100%": "#6d28d9" }}
                      trailColor="#e2e8f0"
                      strokeWidth={9}
                      format={() => (
                        <div style={{ marginTop: "-2px" }}>
                          <div style={{ fontSize: 24, fontWeight: 900, color: "#7c3aed" }}>{compWeekBalTotal}</div>
                          <div style={{ fontSize: 10, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>Off Left</div>
                        </div>
                      )}
                    />
                  </div>

                  <div className="d-flex justify-content-around py-1.5 mt-1" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #e2e8f0" }}>
                    <div>
                      <span style={{ fontSize: 11, color: "#64748b" }}>Comp Bal: </span>
                      <strong style={{ fontSize: 13, color: "#7c3aed", fontWeight: 800 }}>{compoffBal} d</strong>
                    </div>
                    <div style={{ width: 1, background: "#e2e8f0" }} />
                    <div>
                      <span style={{ fontSize: 11, color: "#64748b" }}>Week Bal: </span>
                      <strong style={{ fontSize: 13, color: "#7c3aed", fontWeight: 800 }}>{weekoffBal} d</strong>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between gap-2 mt-3 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Comp Taken</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#d97706" }}>{compoffTaken} Days</div>
                  </div>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Week Taken</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#d97706" }}>{weekoffTaken} Days</div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    );
  };

  // Menu items (memoized)
  const menuItems = useMemo(
    () => [
      { key: "home", icon: <HomeOutlined />, label: "Dashboard" },
      {
        key: "mrf",
        icon: <FormOutlined />,
        label: "MRF",
        children: [
          { key: "applyMRF", icon: <FileAddOutlined />, label: "Apply MRF" },
          { key: "viewRequisitions", icon: <FileTextOutlined />, label: "View Requisitions" },
          { key: "teamRequisitions", icon: <TeamOutlined />, label: "Team Requisitions" },
        ],
      },
      {
        key: "teamLeaves",
        icon: <TeamOutlined />,
        label: "Team Details",
        children: [
          { key: "teamMembers", icon: <FileDoneOutlined />, label: "Team Members" },
          { key: "leaveRequests", icon: <FileDoneOutlined />, label: "Leave Requests" },
          { key: "compoffRequests", icon: <HistoryOutlined />, label: "Team off day workings" },
          { key: "permissionRequests", icon: <ClockCircleOutlined />, label: "Permission Requests" },
          { key: "onduty", icon: <ClockCircleOutlined />, label: "Onduty Requests" },
          { key: "teamattendance", icon: <TeamOutlined />, label: "Team Attendance" },
          { key: "teamemployement", icon: <SolutionOutlined />, label: "Probation" },
          { key: "overall", icon: <CheckCircleOutlined />, label: "Confirmed" },
          { key: "noticeperiod", icon: <CheckCircleOutlined />, label: "Notice Period Employees" },
          { key: "otapproval", icon: <CheckCircleOutlined />, label: "Over Time Requests" },
          {
            key: "pipapprovals",
            icon: <SolutionOutlined />,
            label: "PIP Approvals",
          },
          {
            key: "showselfassessments",
            icon: <RiseOutlined />,
            label: "Team Assessments",
          },
        ],
      },
      { key: "payslip", icon: <WalletOutlined />, label: "Payslip" },
      {
        key: "attendance",
        icon: <ClockCircleOutlined />,
        label: "Attendance",
        children: [
          { key: "myattendance", icon: <ClockCircleOutlined />, label: "View Attendance" },
          { key: "applyOnduty", icon: <HourglassOutlined />, label: "Apply On Duty" },
          {
            key: "appliedOnDuty",
            icon: <HourglassOutlined />,
            label: "Applied On Duty",
          },
        ],
      },
      {
        key: "leaveManagement",
        icon: <CalendarFilled />,
        label: "Leave Management",
        children: [
          { key: "holidays", icon: <CalendarOutlined />, label: "Holidays" },
          { key: "permissions", icon: <ClockCircleOutlined />, label: "Permissions" },
          { key: "leaves", icon: <FileDoneOutlined />, label: "Leaves" },
        ],
      },
      {
        key: "interview",
        icon: <AuditOutlined />,
        label: "Interview & Assessment",
      },
      {
        key: "resignation",
        icon: <MoreOutlined />,
        label: "Others",
        children: [
          { key: "resignation", icon: <LogoutOutlined />, label: "Apply Resignation" },
          {
            key: "resignationRequests",
            icon: <FileTextOutlined />,
            label: "Resignation Requests",
          },
          authData?.assigned_dept_head_id && {
            key: "NocClearence",
            icon: <FileDoneOutlined />,
            label: "NOC Clearance",
          },
          authData?.is_exit_interview_triggered && {
            key: "exitInterview",
            icon: <FormOutlined />,
            label: "Exit Interview",
          },
        ],
      },
    ],
    []
  );

  const handleBack = () => {
    setSelectedMenu("home");
  };

  // ────── HOME PAGE CONTENT (extracted so the switch stays readable) ──────
  const renderHome = () => {
    if (showWelcome) {
      return <Welcome />;
    }

    if (showProfile) {
      return <EmployeeProfile onBack={handleBack} />;
    }

    return (
      <div
        style={{
          background: "linear-gradient(180deg, #f0f4f8 0%, #e8edf5 100%)",
          minHeight: "100vh",
          padding: "0 0 24px",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {authData?.your_under_pip && (
          <div className="pip-alert-banner">
            <span style={{ fontSize: 24, flexShrink: 0 }}>⚠️</span>
            <div>
              <div style={{ fontWeight: 800, color: "#92400e", fontSize: isMobile ? 13 : 15, lineHeight: 1.3 }}>
                You are currently under a Performance Improvement Plan (PIP)
              </div>
              <div style={{ fontWeight: 600, color: "#b45309", fontSize: 12.5, marginTop: 2 }}>
                {authData?.pip_days_remaining} days remaining for your review
              </div>
            </div>
          </div>
        )}

        <div className="container-fluid px-0" style={{ maxWidth: "1600px", margin: "0 auto" }}>
          {/* HERO PROFILE BANNER — Framer Motion Executive Glassmorphism Card */}
          <motion.div
            className="emp-hero-banner mb-4"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, ease: "easeOut" }}
          >
            {/* TOP SECTION: AVATAR + USER INFO + STATUS */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 pb-3">
              <div className="d-flex align-items-center" style={{ gap: "22px" }}>
                {/* Executive Dual-Ring Avatar with Spring Hover */}
                <motion.div
                  className="emp-avatar-wrapper"
                  whileHover={{ scale: 1.06 }}
                  whileTap={{ scale: 0.96 }}
                  transition={{ type: "spring", stiffness: 350, damping: 20 }}
                >
                  <div className="emp-avatar-ring">
                    <img
                      src={authData?.employee?.photo ? (authData.employee.photo.startsWith("http") ? authData.employee.photo : `${backUrl}${authData.employee.photo.startsWith('/') ? '' : '/'}${authData.employee.photo}`) : UserImg}
                      alt="Profile"
                      onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                      className="emp-avatar-img"
                    />
                  </div>
                  <div className="emp-online-status-dot" title="Online Active" />
                </motion.div>

                {/* Greeting & Subtitle Badges */}
                <div className="d-flex flex-column justify-content-center">
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <span style={{ color: "#ffffff", fontWeight: 900, fontSize: isMobile ? 18 : 23, letterSpacing: "-0.5px", lineHeight: 1.2, textShadow: "0 2px 8px rgba(0,0,0,0.18)" }}>
                      Welcome back, {authData?.employee?.first_name || 'HOD / Team Lead'}!
                    </span>
                    <motion.span animate={{ rotate: [0, 14, -8, 14, 0] }} transition={{ repeat: Infinity, repeatDelay: 4, duration: 1.2 }}>
                      👋
                    </motion.span>
                  </div>

                  <div className="d-flex align-items-center gap-2 flex-wrap mt-2" style={{ fontSize: 13, fontWeight: 600 }}>
                    {(authData?.employee?.designation_name || authData?.employee?.role_name) && (
                      <span style={{ fontWeight: 700, color: "rgba(255,255,255,0.95)", display: "inline-flex", alignItems: "center", gap: 5 }}>
                        <ShieldCheck style={{ width: 14, height: 14, color: "#38bdf8" }} />
                        {authData?.employee?.designation_name || authData?.employee?.role_name}
                      </span>
                    )}

                    {(authData?.employee?.department_name || authData?.employee?.department) && (
                      <>
                        <span style={{ color: "rgba(255,255,255,0.35)" }}>•</span>
                        <span style={{ color: "rgba(255,255,255,0.85)" }}>
                          🏢 {authData?.employee?.department_name || authData?.employee?.department}
                        </span>
                      </>
                    )}

                    {(authData?.employee?.emp_code || authData?.employee?.emp_id || authData?.employee?.employee_id) && (
                      <>
                        <span style={{ color: "rgba(255,255,255,0.35)" }}>•</span>
                        <span
                          style={{
                            background: "rgba(255,255,255,0.16)",
                            border: "1px solid rgba(255,255,255,0.28)",
                            color: "#ffffff",
                            borderRadius: 8,
                            padding: "2px 10px",
                            fontSize: 11.5,
                            fontWeight: 800,
                            backdropFilter: "blur(6px)",
                          }}
                        >
                          ID: {authData?.employee?.emp_code || authData?.employee?.emp_id || authData?.employee?.employee_id}
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* Top Right: Today Date & Mode Badge */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div
                  style={{
                    background: "rgba(0, 0, 0, 0.22)",
                    border: "1px solid rgba(255, 255, 255, 0.22)",
                    color: "rgba(255, 255, 255, 0.95)",
                    borderRadius: 30,
                    padding: "6px 16px",
                    fontSize: 12,
                    fontWeight: 700,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <LucideCalendar style={{ width: 14, height: 14, color: "#38bdf8" }} />
                  <span>{new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}</span>
                </div>

                <span className="emp-mode-badge">
                  {dashboardMode === "team" ? "👑 TEAM LEAD" : "👤 MY HUB"}
                </span>
              </div>
            </div>

            {/* BOTTOM SECTION: EXECUTIVE QUICK SHORTCUTS */}
            <div
              className="pt-3 d-flex align-items-center justify-content-between flex-wrap gap-2"
              style={{ borderTop: "1px solid rgba(255, 255, 255, 0.12)" }}
            >
              <div style={{ fontSize: 11.5, textTransform: "uppercase", letterSpacing: "1px", fontWeight: 800, color: "rgba(255, 255, 255, 0.75)", display: "flex", alignItems: "center", gap: 6 }}>
                <Sparkles style={{ width: 14, height: 14, color: "#f59e0b" }} />
                <span>QUICK SHORTCUTS</span>
              </div>

              <div className="d-flex align-items-center gap-2 flex-wrap">
                {dashboardMode === "team" ? (
                  <>
                    <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                      <Button type="text" onClick={() => setSelectedMenu("leaveRequests")} className="emp-action-tile-btn" style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <InboxOutlined style={{ fontSize: 15 }} />
                        <span>Leave Req</span>
                        {(teamPendingData?.counts?.leave || 0) > 0 && (
                          <span style={{ background: "#ef4444", color: "#fff", borderRadius: 20, fontSize: 10.5, fontWeight: 900, padding: "1px 8px", minWidth: 20, textAlign: "center" }}>
                            {teamPendingData?.counts?.leave}
                          </span>
                        )}
                      </Button>
                    </motion.div>

                    <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                      <Button type="text" onClick={() => setSelectedMenu("permissionRequests")} className="emp-action-tile-btn" style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <ClockCircleOutlined style={{ fontSize: 15 }} />
                        <span>Permissions</span>
                        {(teamPendingData?.counts?.permission || 0) > 0 && (
                          <span style={{ background: "#3b82f6", color: "#fff", borderRadius: 20, fontSize: 10.5, fontWeight: 900, padding: "1px 8px", minWidth: 20, textAlign: "center" }}>
                            {teamPendingData?.counts?.permission}
                          </span>
                        )}
                      </Button>
                    </motion.div>

                    <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                      <Button type="text" onClick={() => setSelectedMenu("teamattendance")} className="emp-action-primary-btn" style={{ height: 38, padding: "0 20px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <Users style={{ width: 15, height: 15 }} />
                        <span>Team Roster</span>
                      </Button>
                    </motion.div>
                  </>
                ) : (
                  <>
                    <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                      <Button type="text" onClick={() => setSelectedMenu("profile")} className="emp-action-tile-btn" style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <LucideUser style={{ width: 15, height: 15 }} />
                        <span>Profile</span>
                      </Button>
                    </motion.div>

                    <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                      <Button type="text" onClick={() => setSelectedMenu("myattendance")} className="emp-action-tile-btn" style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <LucideClock style={{ width: 15, height: 15 }} />
                        <span>Attendance</span>
                      </Button>
                    </motion.div>

                    <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                      <Button type="text" onClick={() => setSelectedMenu("leaves")} className="emp-action-tile-btn" style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <FileText style={{ width: 15, height: 15 }} />
                        <span>Apply Leave</span>
                      </Button>
                    </motion.div>

                    <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                      <Button type="text" onClick={() => setSelectedMenu("permissions")} className="emp-action-tile-btn" style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <ClockCircleOutlined style={{ fontSize: 15 }} />
                        <span>Permission</span>
                      </Button>
                    </motion.div>

                    <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                      <Button type="text" onClick={() => setSelectedMenu("payslip")} className="emp-action-primary-btn" style={{ height: 38, padding: "0 20px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <LucideWallet style={{ width: 15, height: 15 }} />
                        <span>Payslip</span>
                      </Button>
                    </motion.div>
                  </>
                )}
              </div>
            </div>
          </motion.div>

          {/* DYNAMIC CONTENT SWITCHING BASED ON MODE */}
          {dashboardMode === "team" ? (
            /* EXECUTIVE TEAM COMMAND HUB */
            <div className="d-flex flex-column gap-4 mb-4">
              {/* 1. ACTIVITY RINGS & REAL-TIME METRICS */}
              <Card
                bordered={false}
                style={{
                  borderRadius: 22,
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 8px 30px rgba(15,23,42,0.06)",
                  background: "#ffffff",
                }}
                bodyStyle={{ padding: "24px" }}
              >
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                  <div>
                    <div style={{ fontWeight: 900, color: "#0f172a", fontSize: 18, marginBottom: 2 }}>
                      Team Activity Rings & Real-Time Metrics
                    </div>
                    <div style={{ fontSize: 12.5, color: "#64748b", fontWeight: 700 }}>
                      Live Subordinate Attendance & Availability Status
                    </div>
                  </div>
                  {hoveredDonutSlice ? (
                    <div style={{ color: hoveredDonutSlice.color, background: `${hoveredDonutSlice.color}15`, border: `1px solid ${hoveredDonutSlice.color}40`, padding: "4px 14px", borderRadius: 12, fontWeight: 800, fontSize: 12 }}>
                      {hoveredDonutSlice.name}: {teamAttendanceData?.counts?.total_members ? Math.round((hoveredDonutSlice.value / teamAttendanceData.counts.total_members) * 100) : 0}%
                    </div>
                  ) : (
                    <Tag color="blue" style={{ borderRadius: 12, padding: "4px 14px", fontWeight: 800, fontSize: 12 }}>
                      👥 Total Team: {teamAttendanceData?.counts?.total_members ?? checkData?.team_count ?? 0} Members
                    </Tag>
                  )}
                </div>

                <Row gutter={[24, 24]} align="middle">
                  {/* RECHARTS MULTI-SEGMENT ACTIVITY DONUT RING */}
                  <Col xs={24} md={9} className="d-flex flex-column align-items-center justify-content-center">
                    {(() => {
                      const c = teamAttendanceData?.counts || {};
                      const total = c.total_members ?? checkData?.team_count ?? 0;
                      const present = c.present ?? 0;

                      const allAbsent = teamAttendanceData?.absent_members || [];
                      const getCombinedStatusStr = (m) => {
                        const t = m.leave_type || m.LeaveType || m.status || m.AttendanceStatus || m.Status || "";
                        const r = m.status_message || m.StatusMessage || m.remarks || m.leave_name || m.leave_type_name || "";
                        return `${t} ${r}`.toUpperCase();
                      };
                      const checkIsWeekOff = (m) => {
                        const s = getCombinedStatusStr(m);
                        return s.includes("WEEK") || s.includes("OFF DAY") || s.includes("SUNDAY") || s.includes("HOLIDAY") || s.includes("WO");
                      };
                      const checkIsCompOff = (m) => {
                        const s = getCombinedStatusStr(m);
                        return s.includes("COMP") || s.includes("CO");
                      };
                      const checkIsSick = (m) => {
                        const s = getCombinedStatusStr(m);
                        return s.includes("SICK") || s.includes("SL");
                      };
                      const checkIsCasual = (m) => {
                        const s = getCombinedStatusStr(m);
                        return s.includes("CASUAL") || s.includes("CL");
                      };
                      const checkIsLop = (m) => {
                        const s = getCombinedStatusStr(m);
                        return s.includes("LOP") || s.includes("NLB") || s.includes("LOSS");
                      };
                      const checkIsHasLeave = (m) => {
                        const s = getCombinedStatusStr(m);
                        return checkIsSick(m) || checkIsCasual(m) || checkIsLop(m) || s.includes("EARNED") || s.includes("LEAVE") || s.includes("EL") || s.includes("HALF");
                      };

                      const weekoffMembers = teamAttendanceData?.weekoff_members?.length > 0 ? teamAttendanceData.weekoff_members : allAbsent.filter(checkIsWeekOff);
                      const compoffMembers = teamAttendanceData?.compoff_members?.length > 0 ? teamAttendanceData.compoff_members : allAbsent.filter(checkIsCompOff);
                      const sickLeaveMembers = allAbsent.filter(checkIsSick);
                      const casualLeaveMembers = allAbsent.filter(checkIsCasual);
                      const lopLeaveMembers = allAbsent.filter(checkIsLop);
                      const pureAbsentMembers = allAbsent.filter(m => !checkIsWeekOff(m) && !checkIsCompOff(m) && !checkIsHasLeave(m));

                      const weekoffCount = c.weekoff_leave || c.week_off || c.weekoff || weekoffMembers.length;
                      const compoffCount = c.compoff_leave || c.comp_off || c.compoff || compoffMembers.length;

                      const dashboardStats = [
                        { name: "Present", label: "Present", value: c.present ?? 0, color: "#10B981", modalTitle: "Present Subordinates Today", members: teamAttendanceData?.present_members || [] },
                        { name: "On Duty", label: "On Duty", value: c.onduty ?? 0, color: "#6366F1", modalTitle: "On-Duty Requests Today", members: teamAttendanceData?.onduty_members || [] },
                        { name: "Absent", label: "Absent", value: c.unplanned_absent ?? pureAbsentMembers.length, color: "#F43F5E", modalTitle: "Absent Subordinates Today", members: pureAbsentMembers },
                        { name: "Late In", label: "Late In", value: c.late_in ?? 0, color: "#F59E0B", modalTitle: "Late In Check-ins Today", members: teamAttendanceData?.late_in_members || [] },
                        { name: "Permission", label: "Permission", value: c.permission ?? 0, color: "#98FF66", modalTitle: "Permission Applications Today", members: teamAttendanceData?.permission_members || [] },
                        { name: "Sick Leave", label: "Sick Leave", value: c.sick_leave ?? sickLeaveMembers.length, color: "#FF0066", modalTitle: "Sick Leave Subordinates Today", members: sickLeaveMembers },
                        { name: "Casual Leave", label: "Casual Leave", value: c.casual_leave ?? casualLeaveMembers.length, color: "#CB00CC", modalTitle: "Casual Leave Subordinates Today", members: casualLeaveMembers },
                        { name: "Comp Off", label: "Comp Off", value: compoffCount, color: "#1FA2CC", modalTitle: "Comp Off Members Today", members: compoffMembers },
                        { name: "NLB", label: "NLB", value: c.lop_leave ?? lopLeaveMembers.length, color: "#bf4406", modalTitle: "NLB (Loss of Pay) Subordinates Today", members: lopLeaveMembers },
                        { name: "Week Off", label: "Week Off", value: weekoffCount, color: "#FFFF00", modalTitle: "Week Off Members Today", members: weekoffMembers },
                      ];

                      const activeData = dashboardStats.filter(d => d.value > 0);
                      const pieData = activeData.length > 0 ? activeData : [{ name: "No Data", label: "No Data", value: 1, color: "#cbd5e1" }];

                      return (
                        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                          <div style={{ position: "relative", width: 185, height: 185, margin: "0 auto" }}>
                            <ResponsiveContainer width="100%" height="100%">
                              <PieChart>
                                <Pie
                                  data={pieData}
                                  cx="50%"
                                  cy="50%"
                                  innerRadius={56}
                                  outerRadius={82}
                                  paddingAngle={4}
                                  dataKey="value"
                                  stroke="none"
                                  onMouseEnter={(data) => setHoveredDonutSlice(data)}
                                  onMouseLeave={() => setHoveredDonutSlice(null)}
                                >
                                  {pieData.map((entry, index) => (
                                    <Cell
                                      key={`cell-${index}`}
                                      fill={entry.color}
                                      style={{
                                        outline: "none",
                                        cursor: "pointer",
                                        filter: hoveredDonutSlice?.name === entry.name ? "brightness(1.15) drop-shadow(0px 2px 6px rgba(0,0,0,0.25))" : "none",
                                        transform: hoveredDonutSlice?.name === entry.name ? "scale(1.04)" : "scale(1)",
                                        transformOrigin: "center center",
                                        transition: "all 0.18s ease"
                                      }}
                                    />
                                  ))}
                                </Pie>
                              </PieChart>
                            </ResponsiveContainer>

                            {/* INTERACTIVE CENTER OVERLAY */}
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                textAlign: "center",
                                pointerEvents: "none",
                                width: 105,
                                zIndex: 2
                              }}
                            >
                              {hoveredDonutSlice && hoveredDonutSlice.name !== "No Data" ? (
                                <>
                                  <div style={{ fontSize: 24, fontWeight: 900, color: hoveredDonutSlice.color || "#0f172a", lineHeight: 1 }}>
                                    {hoveredDonutSlice.value}
                                  </div>
                                  <div style={{ fontSize: 9.5, color: hoveredDonutSlice.color || "#64748b", fontWeight: 900, marginTop: 3, textTransform: "uppercase", letterSpacing: "0.03em", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {hoveredDonutSlice.name}
                                  </div>
                                  <div style={{ fontSize: 9, color: hoveredDonutSlice.color || "#059669", fontWeight: 800, marginTop: 3, background: `${hoveredDonutSlice.color}18`, border: `1px solid ${hoveredDonutSlice.color}40`, padding: "1px 6px", borderRadius: 10, display: "inline-block" }}>
                                    {total > 0 ? Math.round((hoveredDonutSlice.value / total) * 100) : 0}% of Total
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div style={{ fontSize: 26, fontWeight: 900, color: "#0f172a", lineHeight: 1 }}>{total}</div>
                                  <div style={{ fontSize: 9.5, color: "#64748b", fontWeight: 800, marginTop: 2, letterSpacing: "0.05em" }}>TOTAL STAFF</div>
                                  <div style={{ fontSize: 9.5, color: "#059669", fontWeight: 800, marginTop: 2, background: "#ecfdf5", border: "1px solid #a7f3d0", padding: "1px 8px", borderRadius: 10, display: "inline-block" }}>
                                    {total > 0 ? Math.round((present / total) * 100) : 0}% Turnout
                                  </div>
                                </>
                              )}
                            </div>
                          </div>

                          {/* INLINE STATUS LEGEND BELOW DONUT */}
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, justifyContent: "center", marginTop: 10 }}>
                            {activeData.map(item => {
                              const isHovered = hoveredDonutSlice?.name === item.name;
                              return (
                                <span
                                  key={item.name}
                                  onMouseEnter={() => setHoveredDonutSlice(item)}
                                  onMouseLeave={() => setHoveredDonutSlice(null)}
                                  style={{
                                    fontSize: 11,
                                    fontWeight: 800,
                                    color: item.color,
                                    background: isHovered ? `${item.color}30` : `${item.color}15`,
                                    border: `1.5px solid ${item.color}${isHovered ? '80' : '40'}`,
                                    padding: "2px 9px",
                                    borderRadius: 12,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 5,
                                    cursor: "pointer",
                                    transform: isHovered ? "scale(1.06)" : "scale(1)",
                                    transition: "all 0.15s ease"
                                  }}
                                >
                                  <span style={{ width: 8, height: 8, borderRadius: "50%", background: item.color }} />
                                  {item.label}: {item.value}
                                </span>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })()}
                  </Col>

                  {/* SIDE-BY-SIDE REAL-TIME METRIC CARDS */}
                  <Col xs={24} md={15}>
                    {(() => {
                      const c = teamAttendanceData?.counts || {};
                      const present = c.present ?? 0;
                      const permission = c.permission ?? 0;
                      const onduty = c.onduty ?? 0;
                      const late = c.late_in ?? 0;
                      const pendingTotal = (teamPendingData?.counts?.leave || 0) + (teamPendingData?.counts?.permission || 0) + (teamPendingData?.counts?.onduty || 0) + (teamPendingData?.counts?.off_day_working || 0);

                      const allAbsent = teamAttendanceData?.absent_members || [];
                      const getCombinedStatusStr = (m) => {
                        const t = m.leave_type || m.LeaveType || m.status || m.AttendanceStatus || m.Status || "";
                        const r = m.status_message || m.StatusMessage || m.remarks || m.leave_name || m.leave_type_name || "";
                        return `${t} ${r}`.toUpperCase();
                      };
                      const checkIsWeekOff = (m) => {
                        const s = getCombinedStatusStr(m);
                        return s.includes("WEEK") || s.includes("OFF DAY") || s.includes("SUNDAY") || s.includes("HOLIDAY") || s.includes("WO");
                      };
                      const checkIsCompOff = (m) => {
                        const s = getCombinedStatusStr(m);
                        return s.includes("COMP") || s.includes("CO");
                      };
                      const checkIsSick = (m) => {
                        const s = getCombinedStatusStr(m);
                        return s.includes("SICK") || s.includes("SL");
                      };
                      const checkIsCasual = (m) => {
                        const s = getCombinedStatusStr(m);
                        return s.includes("CASUAL") || s.includes("CL");
                      };
                      const checkIsLop = (m) => {
                        const s = getCombinedStatusStr(m);
                        return s.includes("LOP") || s.includes("NLB") || s.includes("LOSS");
                      };
                      const checkIsHasLeave = (m) => {
                        const s = getCombinedStatusStr(m);
                        return checkIsSick(m) || checkIsCasual(m) || checkIsLop(m) || s.includes("EARNED") || s.includes("LEAVE") || s.includes("EL") || s.includes("HALF");
                      };

                      const weekoffMembers = teamAttendanceData?.weekoff_members?.length > 0 ? teamAttendanceData.weekoff_members : allAbsent.filter(checkIsWeekOff);
                      const compoffMembers = teamAttendanceData?.compoff_members?.length > 0 ? teamAttendanceData.compoff_members : allAbsent.filter(checkIsCompOff);
                      const actualOnLeaveMembers = allAbsent.filter(m => !checkIsWeekOff(m) && !checkIsCompOff(m));

                      const totalLeaves = (c.casual_leave || 0) + (c.sick_leave || 0) + (c.earned_leave || 0) + (c.lop_leave || 0) || actualOnLeaveMembers.length;
                      const weekoffCount = c.weekoff_leave || c.week_off || c.weekoff || weekoffMembers.length;
                      const compoffCount = c.compoff_leave || c.comp_off || c.compoff || compoffMembers.length;

                      return (
                        <Row gutter={[10, 10]}>
                          <Col xs={12} sm={8} md={8}>
                            <div
                              onClick={() => setMemberCategoryModal({ visible: true, title: "Present Subordinates Today", members: teamAttendanceData?.present_members || [], color: "#10b981" })}
                              className="d-flex align-items-center justify-content-between p-3"
                              style={{ background: "#f0fdf4", border: "1.5px solid #bbf7d0", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                              onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                              onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span style={{ background: "#10b981", width: 10, height: 10, borderRadius: "50%", display: "inline-block" }} />
                                <span style={{ fontWeight: 800, color: "#065f46", fontSize: 13 }}>Present</span>
                              </div>
                              <Tag color="green" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                {present}
                              </Tag>
                            </div>
                          </Col>

                          <Col xs={12} sm={8} md={8}>
                            <div
                              onClick={() => setMemberCategoryModal({ visible: true, title: "Subordinates On Leave Today", members: actualOnLeaveMembers, color: "#ef4444" })}
                              className="d-flex align-items-center justify-content-between p-3"
                              style={{ background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                              onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                              onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span style={{ background: "#ef4444", width: 10, height: 10, borderRadius: "50%", display: "inline-block" }} />
                                <span style={{ fontWeight: 800, color: "#991b1b", fontSize: 13 }}>On Leaves</span>
                              </div>
                              <Tag color="red" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                {totalLeaves}
                              </Tag>
                            </div>
                          </Col>

                          <Col xs={12} sm={8} md={8}>
                            <div
                              onClick={() => setMemberCategoryModal({ visible: true, title: "🌴 Week Off Members Today", members: weekoffMembers, color: "#eab308" })}
                              className="d-flex align-items-center justify-content-between p-3"
                              style={{ background: "#fefce8", border: "1.5px solid #fef08a", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                              onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                              onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span style={{ background: "#eab308", width: 10, height: 10, borderRadius: "50%", display: "inline-block" }} />
                                <span style={{ fontWeight: 800, color: "#854d0e", fontSize: 13 }}>Week Off</span>
                              </div>
                              <Tag color="gold" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                {weekoffCount}
                              </Tag>
                            </div>
                          </Col>

                          <Col xs={12} sm={8} md={8}>
                            <div
                              onClick={() => setMemberCategoryModal({ visible: true, title: "⚡ Comp Off Members Today", members: compoffMembers, color: "#ca8a04" })}
                              className="d-flex align-items-center justify-content-between p-3"
                              style={{ background: "#fef9c3", border: "1.5px solid #fef08a", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                              onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                              onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span style={{ background: "#ca8a04", width: 10, height: 10, borderRadius: "50%", display: "inline-block" }} />
                                <span style={{ fontWeight: 800, color: "#713f12", fontSize: 13 }}>Comp Off</span>
                              </div>
                              <Tag color="warning" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                {compoffCount}
                              </Tag>
                            </div>
                          </Col>

                          <Col xs={12} sm={8} md={8}>
                            <div
                              onClick={() => setMemberCategoryModal({ visible: true, title: "Permission Applications Today", members: teamAttendanceData?.permission_members || [], color: "#3b82f6" })}
                              className="d-flex align-items-center justify-content-between p-3"
                              style={{ background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                              onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                              onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span style={{ background: "#3b82f6", width: 10, height: 10, borderRadius: "50%", display: "inline-block" }} />
                                <span style={{ fontWeight: 800, color: "#1e40af", fontSize: 13 }}>Permission</span>
                              </div>
                              <Tag color="blue" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                {permission}
                              </Tag>
                            </div>
                          </Col>

                          <Col xs={12} sm={8} md={8}>
                            <div
                              onClick={() => setMemberCategoryModal({ visible: true, title: "On-Duty Requests Today", members: teamAttendanceData?.onduty_members || [], color: "#8b5cf6" })}
                              className="d-flex align-items-center justify-content-between p-3"
                              style={{ background: "#f5f3ff", border: "1.5px solid #ddd6fe", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                              onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                              onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span style={{ background: "#8b5cf6", width: 10, height: 10, borderRadius: "50%", display: "inline-block" }} />
                                <span style={{ fontWeight: 800, color: "#5b21b6", fontSize: 13 }}>On Duty</span>
                              </div>
                              <Tag color="purple" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                {onduty}
                              </Tag>
                            </div>
                          </Col>

                          <Col xs={12} sm={8} md={8}>
                            <div
                              onClick={() => setMemberCategoryModal({ visible: true, title: "Late In Check-ins Today", members: teamAttendanceData?.late_in_members || [], color: "#f59e0b" })}
                              className="d-flex align-items-center justify-content-between p-3"
                              style={{ background: "#fffbeb", border: "1.5px solid #fde68a", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                              onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                              onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span style={{ background: "#f59e0b", width: 10, height: 10, borderRadius: "50%", display: "inline-block" }} />
                                <span style={{ fontWeight: 800, color: "#92400e", fontSize: 13 }}>Late In</span>
                              </div>
                              <Tag color="gold" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                {late}
                              </Tag>
                            </div>
                          </Col>

                          <Col xs={12} sm={8} md={8}>
                            <div
                              onClick={() => setPendingRequestsModal(true)}
                              className="d-flex align-items-center justify-content-between p-3"
                              style={{ background: "#fff7ed", border: "1.5px solid #fed7aa", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                              onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                              onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <span style={{ background: "#f97316", width: 10, height: 10, borderRadius: "50%", display: "inline-block" }} />
                                <span style={{ fontWeight: 800, color: "#9a3412", fontSize: 13 }}>Pending Requests</span>
                              </div>
                              <Tag color="orange" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                {pendingTotal}
                              </Tag>
                            </div>
                          </Col>
                        </Row>
                      );
                    })()}
                  </Col>
                </Row>
              </Card>

              {/* 2. ON LEAVES (ONLY ACTUAL LEAVES - EXCLUDING WEEK OFF & COMP OFF) + WEEK OFF/COMP OFF */}
              {(() => {
                const allAbsent = teamAttendanceData?.absent_members || [];
                const checkIsWeekOff = (m) => {
                  const t = (m.leave_type || m.LeaveType || m.status || m.AttendanceStatus || m.Status || "").toUpperCase();
                  const r = (m.StatusMessage || m.remarks || "").toUpperCase();
                  const combined = `${t} ${r}`;
                  return combined.includes("WEEK") || combined.includes("OFF DAY") || combined.includes("SUNDAY") || combined.includes("HOLIDAY") || t === "WO";
                };
                const checkIsCompOff = (m) => {
                  const t = (m.leave_type || m.LeaveType || m.status || m.AttendanceStatus || m.Status || "").toUpperCase();
                  const r = (m.StatusMessage || m.remarks || "").toUpperCase();
                  const combined = `${t} ${r}`;
                  return combined.includes("COMP") || combined.includes("CO");
                };

                const actualOnLeaveMembers = allAbsent.filter(m => !checkIsWeekOff(m) && !checkIsCompOff(m));
                const offDayMembers = allAbsent.filter(m => checkIsWeekOff(m) || checkIsCompOff(m));

                return (
                  <>
                    <Card
                      title={
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ width: 4, height: 18, background: "#ef4444", borderRadius: 4 }} />
                            <span style={{ fontWeight: 900, color: "#0f172a", fontSize: 16 }}>
                              On Leaves Today
                            </span>
                            <Tag color="red" style={{ borderRadius: 10, fontWeight: 800, fontSize: 11, margin: 0 }}>
                              {actualOnLeaveMembers.length}
                            </Tag>
                          </div>
                          {actualOnLeaveMembers.length > 0 && (
                            <Button
                              type="link"
                              size="small"
                              style={{ fontWeight: 800, color: "#ef4444" }}
                              onClick={() => setMemberCategoryModal({
                                visible: true,
                                title: "🔴 On Leave Members Today",
                                members: actualOnLeaveMembers,
                                color: "#dc2626"
                              })}
                            >
                              View All →
                            </Button>
                          )}
                        </div>
                      }
                      bordered={false}
                      style={{
                        borderRadius: 22,
                        border: "1px solid #e2e8f0",
                        boxShadow: "0 8px 30px rgba(15,23,42,0.06)",
                        background: "#ffffff",
                        marginBottom: 16
                      }}
                      bodyStyle={{ padding: "16px 20px" }}
                    >
                      {actualOnLeaveMembers.length > 0 ? (
                        <div className="team-avatar-scroll-container">
                          {actualOnLeaveMembers.map((member, idx) => {
                            const photoPath = member.profile_picture || member.photo || member.profile_photo || member.avatar;
                            const fullUrl = photoPath ? (photoPath.startsWith("http") ? photoPath : `${backUrl}${photoPath.startsWith('/') ? '' : '/'}${photoPath}`) : UserImg;
                            const badgeInfo = getLeaveColorAndBadge(member);

                            return (
                              <div
                                className="team-member-avatar-card"
                                key={member.id || idx}
                                onClick={() => {
                                  setSelectedLogMember(member);
                                  setLogModalVisible(true);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="team-member-avatar-box">
                                  <img
                                    src={fullUrl}
                                    alt={member.name || "Member"}
                                    onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                                    className="team-member-avatar-img"
                                  />
                                  <div className="team-member-status-dot" style={{ background: badgeInfo.color }}>{badgeInfo.icon}</div>
                                </div>
                                <div className="team-member-name-label">
                                  {member.name || member.full_name || `${member.first_name || ''} ${member.last_name || ''}`}
                                </div>
                                <div className="team-member-sub-label" style={{ color: badgeInfo.text, fontWeight: 700 }}>
                                  {badgeInfo.label}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="py-3 text-center text-muted" style={{ fontSize: 13, fontWeight: 600 }}>
                          🎉 No team members are on leave today.
                        </div>
                      )}
                    </Card>

                    {/* DEDICATED WEEK OFF & COMP OFF AVATAR SECTION */}
                    {offDayMembers.length > 0 && (
                      <Card
                        title={
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-2">
                              <div style={{ width: 4, height: 18, background: "#eab308", borderRadius: 4 }} />
                              <span style={{ fontWeight: 900, color: "#0f172a", fontSize: 16 }}>
                                Week Off & Comp Off Today
                              </span>
                              <Tag color="gold" style={{ borderRadius: 10, fontWeight: 800, fontSize: 11, margin: 0 }}>
                                {offDayMembers.length}
                              </Tag>
                            </div>
                            <Button
                              type="link"
                              size="small"
                              style={{ fontWeight: 800, color: "#b45309" }}
                              onClick={() => setMemberCategoryModal({
                                visible: true,
                                title: "🌴 Week Off & Comp Off Members Today",
                                members: offDayMembers,
                                color: "#eab308"
                              })}
                            >
                              View All →
                            </Button>
                          </div>
                        }
                        bordered={false}
                        style={{
                          borderRadius: 22,
                          border: "1px solid #fef08a",
                          boxShadow: "0 8px 30px rgba(234,179,8,0.06)",
                          background: "#fffdf0",
                          marginBottom: 16
                        }}
                        bodyStyle={{ padding: "16px 20px" }}
                      >
                        <div className="team-avatar-scroll-container">
                          {offDayMembers.map((member, idx) => {
                            const photoPath = member.profile_picture || member.photo || member.profile_photo || member.avatar;
                            const fullUrl = photoPath ? (photoPath.startsWith("http") ? photoPath : `${backUrl}${photoPath.startsWith('/') ? '' : '/'}${photoPath}`) : UserImg;
                            const leaveTypeStr = (member.leave_type || member.status || "Off Day").trim();
                            const isComp = checkIsCompOff(member);

                            return (
                              <div
                                className="team-member-avatar-card"
                                key={member.id || idx}
                                style={{ borderColor: "#fde047", background: "#ffffff" }}
                                onClick={() => {
                                  setSelectedLogMember(member);
                                  setLogModalVisible(true);
                                }}
                              >
                                <div className="team-member-avatar-box">
                                  <img
                                    src={fullUrl}
                                    alt={member.name || "Member"}
                                    onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                                    className="team-member-avatar-img"
                                  />
                                  <div
                                    className="team-member-status-dot weekoff"
                                    style={{ background: isComp ? "#ca8a04" : "#eab308", color: "#fff", fontSize: 10, fontWeight: 900 }}
                                  >
                                    {isComp ? "⚡" : "🌴"}
                                  </div>
                                </div>
                                <div className="team-member-name-label">
                                  {member.name || member.full_name || `${member.first_name || ''} ${member.last_name || ''}`}
                                </div>
                                <div
                                  className="team-member-sub-label"
                                  style={{ color: "#854d0e", fontWeight: 800, background: "#fef9c3", padding: "1px 6px", borderRadius: 8 }}
                                >
                                  {leaveTypeStr}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </Card>
                    )}
                  </>
                );
              })()}

              {/* 3. LATE IN TODAY (HORIZONTAL SCROLLING AVATAR CARDS) */}
              <Card
                title={
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ width: 4, height: 18, background: "#f59e0b", borderRadius: 4 }} />
                      <span style={{ fontWeight: 900, color: "#0f172a", fontSize: 16 }}>
                        Late In Today
                      </span>
                      <Tag color="gold" style={{ borderRadius: 10, fontWeight: 800, fontSize: 11, margin: 0 }}>
                        {teamAttendanceData?.late_in_members?.length || 0}
                      </Tag>
                    </div>
                    {teamAttendanceData?.late_in_members?.length > 0 && (
                      <Button
                        type="link"
                        size="small"
                        style={{ fontWeight: 800, color: "#d97706" }}
                        onClick={() => setMemberCategoryModal({
                          visible: true,
                          title: "⏰ Late In Members Today",
                          members: teamAttendanceData?.late_in_members || [],
                          color: "#d97706"
                        })}
                      >
                        View All →
                      </Button>
                    )}
                  </div>
                }
                bordered={false}
                style={{
                  borderRadius: 22,
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 8px 30px rgba(15,23,42,0.06)",
                  background: "#ffffff",
                }}
                bodyStyle={{ padding: "16px 20px" }}
              >
                {teamAttendanceData?.late_in_members?.length > 0 ? (
                  <div className="team-avatar-scroll-container">
                    {teamAttendanceData.late_in_members.map((member, idx) => {
                      const photoPath = member.profile_picture || member.photo || member.profile_photo || member.avatar;
                      const fullUrl = photoPath ? (photoPath.startsWith("http") ? photoPath : `${backUrl}${photoPath.startsWith('/') ? '' : '/'}${photoPath}`) : UserImg;
                      return (
                        <div
                          className="team-member-avatar-card"
                          key={member.id || idx}
                          onClick={() => {
                            setSelectedLogMember(member);
                            setLogModalVisible(true);
                          }}
                        >
                          <div className="team-member-avatar-box">
                            <img
                              src={fullUrl}
                              alt={member.name || "Member"}
                              onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                              className="team-member-avatar-img"
                            />
                            <div className="team-member-status-dot late">⏰</div>
                          </div>
                          <div className="team-member-name-label">
                            {member.name || member.full_name || `${member.first_name || ''} ${member.last_name || ''}`}
                          </div>
                          <div className="team-member-sub-label">
                            {member.check_in_time || "Late"}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="py-3 text-center text-muted" style={{ fontSize: 13, fontWeight: 600 }}>
                    ⚡ No late check-ins recorded today.
                  </div>
                )}
              </Card>

              {/* 4. PRESENT TODAY (HORIZONTAL SCROLLING AVATAR CARDS) */}
              <Card
                title={
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ width: 4, height: 18, background: "#10b981", borderRadius: 4 }} />
                      <span style={{ fontWeight: 900, color: "#0f172a", fontSize: 16 }}>
                        Present Today
                      </span>
                      <Tag color="green" style={{ borderRadius: 10, fontWeight: 800, fontSize: 11, margin: 0 }}>
                        {teamAttendanceData?.present_members?.length || 0}
                      </Tag>
                    </div>
                    {teamAttendanceData?.present_members?.length > 0 && (
                      <Button
                        type="link"
                        size="small"
                        style={{ fontWeight: 800, color: "#059669" }}
                        onClick={() => setMemberCategoryModal({
                          visible: true,
                          title: "🟢 Present Members Today",
                          members: teamAttendanceData?.present_members || [],
                          color: "#059669"
                        })}
                      >
                        View All →
                      </Button>
                    )}
                  </div>
                }
                bordered={false}
                style={{
                  borderRadius: 22,
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 8px 30px rgba(15,23,42,0.06)",
                  background: "#ffffff",
                }}
                bodyStyle={{ padding: "16px 20px" }}
              >
                {teamAttendanceData?.present_members?.length > 0 ? (
                  <div className="team-avatar-scroll-container">
                    {teamAttendanceData.present_members.map((member, idx) => {
                      const photoPath = member.profile_picture || member.photo || member.profile_photo || member.avatar;
                      const fullUrl = photoPath ? (photoPath.startsWith("http") ? photoPath : `${backUrl}${photoPath.startsWith('/') ? '' : '/'}${photoPath}`) : UserImg;
                      return (
                        <div
                          className="team-member-avatar-card"
                          key={member.id || idx}
                          onClick={() => {
                            setSelectedLogMember(member);
                            setLogModalVisible(true);
                          }}
                        >
                          <div className="team-member-avatar-box">
                            <img
                              src={fullUrl}
                              alt={member.name || "Member"}
                              onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                              className="team-member-avatar-img"
                            />
                            <div className="team-member-status-dot present">✓</div>
                          </div>
                          <div className="team-member-name-label">
                            {member.name || member.full_name || `${member.first_name || ''} ${member.last_name || ''}`}
                          </div>
                          <div className="team-member-sub-label">
                            {member.check_in_time || "Present"}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="py-3 text-center text-muted" style={{ fontSize: 13, fontWeight: 600 }}>
                    👥 No present members checked in yet today.
                  </div>
                )}
              </Card>
            </div>
          ) : (
            /* SELF VIEW CONTENT */
            <div className="d-flex flex-column gap-4 mb-4">
              <div className="row g-4 align-items-stretch">
                {/* LEFT SECTION - LEAVE CALENDAR */}
                <div className="col-12 col-lg-8 d-flex flex-column">
                  <Card
                    bordered={false}
                    style={{
                      borderRadius: "16px",
                      boxShadow: "0 4px 20px rgba(14, 73, 123, 0.06)",
                      background: "#ffffff",
                      flex: 1,
                      width: "100%",
                    }}
                    bodyStyle={{ padding: isMobile ? "12px" : "20px 20px 24px" }}
                  >
                    <div style={{ width: "100%", paddingBottom: "8px" }}>
                      <LeaveCalendar />
                    </div>
                  </Card>
                </div>

                {/* RIGHT SECTION - DISTINCT EVENTS CARD & ANNOUNCEMENTS CARD */}
                <div className="col-12 col-lg-4 d-flex flex-column gap-3">
                  {/* CARD 1: EVENTS TODAY */}
                  <Card
                    bordered={false}
                    style={{
                      borderRadius: "16px",
                      boxShadow: "0 4px 20px rgba(14, 73, 123, 0.06)",
                      background: "#ffffff",
                      border: "1px solid #e2e8f0",
                    }}
                    bodyStyle={{
                      padding: isMobile ? "12px" : "16px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center gap-2">
                        <span style={{ fontSize: 18 }}>🎉</span>
                        <span style={{ fontWeight: 800, color: "#1e293b", fontSize: 15 }}>
                          Events Today
                        </span>
                      </div>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => setEventsModalVisible(true)}
                        style={{
                          background: "linear-gradient(135deg, #d97706 0%, #ea580c 100%)",
                          border: "none",
                          borderRadius: "14px",
                          fontWeight: 700,
                          fontSize: 11.5,
                          boxShadow: "0 2px 8px rgba(217, 119, 6, 0.3)",
                        }}
                      >
                        View ({celebrations.birthdays.length + celebrations.work_anniversaries.length})
                      </Button>
                    </div>

                    {celebrations.birthdays.length === 0 && celebrations.work_anniversaries.length === 0 ? (
                      <div style={{ background: "#f8fafc", borderRadius: 10, padding: "12px 14px", color: "#64748b", fontSize: 12.5, fontStyle: "italic" }}>
                        No birthdays or work anniversaries scheduled for today.
                      </div>
                    ) : (
                      <div className="d-flex flex-column gap-2">
                        {celebrations.birthdays.map((emp) => (
                          <div key={emp.id} className="d-flex align-items-center justify-content-between p-2" style={{ background: "#fff5f5", border: "1px solid #ffe3e3", borderRadius: 10, cursor: "pointer" }} onClick={() => setEventsModalVisible(true)}>
                            <div className="d-flex align-items-center gap-2">
                              <span style={{ fontSize: 16 }}>🎂</span>
                              <span style={{ fontWeight: 700, fontSize: 13, color: "#c92a2a" }}>
                                {emp.full_name || `${emp.user?.first_name || ''} ${emp.user?.last_name || ''}`.trim() || "Employee"}
                              </span>
                            </div>
                            <Tag color="pink" style={{ fontSize: 11, fontWeight: 700, borderRadius: 10, margin: 0 }}>Birthday</Tag>
                          </div>
                        ))}
                        {celebrations.work_anniversaries.map((emp) => (
                          <div key={emp.id} className="d-flex align-items-center justify-content-between p-2" style={{ background: "#f3f0ff", border: "1px solid #e5dbff", borderRadius: 10, cursor: "pointer" }} onClick={() => setEventsModalVisible(true)}>
                            <div className="d-flex align-items-center gap-2">
                              <span style={{ fontSize: 16 }}>🏆</span>
                              <span style={{ fontWeight: 700, fontSize: 13, color: "#5f3dc4" }}>
                                {emp.full_name || `${emp.user?.first_name || ''} ${emp.user?.last_name || ''}`.trim() || "Employee"}
                              </span>
                            </div>
                            <Tag color="purple" style={{ fontSize: 11, fontWeight: 700, borderRadius: 10, margin: 0 }}>Anniversary</Tag>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* 💌 MY WISHES SECTION */}
                    <Card
                      bordered={false}
                      style={{
                        borderRadius: "12px",
                        padding: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                        background: "#FFFBEB",
                        border: "1px solid #FEF3C7",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                        <span style={{ fontWeight: 800, color: "#b45309", fontSize: 13.5, display: "inline-flex", alignItems: "center", gap: 5 }}>
                          💌 My Wishes Received
                        </span>
                        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                          {mywishes?.length > 0 && (
                            <Tag color="warning" style={{ borderRadius: 10, fontWeight: 800, fontSize: 10, margin: 0 }}>
                              {mywishes.length}
                            </Tag>
                          )}
                          {mywishes?.length > 0 && (
                            <Button
                              type="link"
                              size="small"
                              onClick={() => setWishesModalVisible(true)}
                              style={{ fontSize: 11, fontWeight: 800, color: "#d97706", padding: 0, height: "auto" }}
                            >
                              View All →
                            </Button>
                          )}
                        </div>
                      </div>

                      {mywishes?.length > 0 ? (
                        <div className="d-flex flex-column gap-2" style={{ maxHeight: 180, overflowY: "auto" }}>
                          {mywishes.map((wish, idx) => (
                            <div
                              key={wish.id || idx}
                              onClick={() => setWishesModalVisible(true)}
                              style={{ background: "#ffffff", border: "1px solid #fef3c7", borderRadius: 10, padding: "8px 12px", cursor: "pointer" }}
                            >
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span style={{ fontSize: 12.5, fontWeight: 800, color: "#0f172a" }}>{wish.sender_name}</span>
                                <span style={{ fontSize: 10, color: "#b45309", fontWeight: 700 }}>{wish.occasion || "Celebration"}</span>
                              </div>
                              <div style={{ margin: "3px 0 0 0", fontSize: 12, fontStyle: "italic", color: "#334155" }}>
                                "{wish.message}"
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p style={{ textAlign: "center", color: "#888", margin: 0, fontSize: 12 }}>
                          You haven't received any wishes yet ✨
                        </p>
                      )}
                    </Card>
                  </Card>

                  {/* CARD 2: ANNOUNCEMENTS */}
                  <Card
                    bordered={false}
                    style={{
                      borderRadius: "16px",
                      boxShadow: "0 4px 20px rgba(14, 73, 123, 0.06)",
                      background: "#ffffff",
                      border: "1px solid #e2e8f0",
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                    bodyStyle={{
                      padding: isMobile ? "12px" : "16px",
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                    }}
                  >
                    <div style={{ flex: 1, width: "100%", overflowY: "auto" }}>
                      <ViewAnnouncement />
                    </div>
                  </Card>
                </div>
              </div>
              {leaveDetails && <LeaveSummary data={leaveDetails} />}
            </div>
          )}
        </div>

        {/* MODALS */}
        {/* EVENTS MODAL */}
        <Modal
          title="Events Today"
          open={eventsModalVisible}
          onCancel={() => setEventsModalVisible(false)}
          footer={null}
          width={isMobile ? "95%" : 900}
          style={{ top: isMobile ? 20 : undefined }}
        >
          {celebrations.birthdays.length === 0 &&
            celebrations.work_anniversaries.length === 0 ? (
            <p>No events today 🎈</p>
          ) : (
            <>
              {celebrations.birthdays.length > 0 && (
                <Card
                  title="🎂 Birthdays"
                  size="small"
                  className="mb-3"
                >
                  {celebrations.birthdays.map((emp) => (
                    <div key={emp.id}>
                      <ViewBirthDay employee={emp} />
                      <br />
                    </div>
                  ))}
                </Card>
              )}

              {celebrations.work_anniversaries.length > 0 && (
                <Card title="🏆 Work Anniversaries" size="small">
                  {celebrations.work_anniversaries.map((emp) => (
                    <WorkCard key={emp.id} employee={emp} />
                  ))}
                </Card>
              )}
            </>
          )}
        </Modal>

        {/* SEND WISH MODAL */}
        <Modal
          title={`Send Wish to ${selectedPerson
            ? `${selectedPerson.user.first_name} ${selectedPerson.user.last_name}`
            : ""
            }`}
          open={wishModalVisible}
          onCancel={() => {
            if (!isSendingWish) setWishModalVisible(false);
          }}
          onOk={handleSendWish}
          okText="Send Wish 🎉"
          confirmLoading={isSendingWish}
          okButtonProps={{
            loading: isSendingWish,
            style: {
              background: "linear-gradient(135deg, #ff7f7f 0%, #ff5252 100%)",
              borderColor: "transparent",
              color: "#fff",
              fontWeight: 800,
              borderRadius: "8px",
            }
          }}
          width={isMobile ? "95%" : 520}
          style={{ top: isMobile ? 20 : undefined }}
        >
          <TextArea
            rows={4}
            placeholder="Write your message..."
            value={wishMessage}
            onChange={(e) => setWishMessage(e.target.value)}
            style={{
              borderRadius: "8px",
            }}
          />
        </Modal>

        {/* MY WISHES RECEIVED MODAL */}
        <Modal
          title={
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: 22 }}>💌</span>
              <span style={{ fontWeight: 800, color: "#b45309", fontSize: 18 }}>My Wishes Received</span>
              {mywishes?.length > 0 && (
                <Tag color="warning" style={{ borderRadius: 10, fontWeight: 800, fontSize: 11 }}>
                  {mywishes.length} Wishes
                </Tag>
              )}
            </div>
          }
          open={wishesModalVisible}
          onCancel={() => { setWishesModalVisible(false); setWishesSearchQuery(""); }}
          footer={null}
          width={isMobile ? "95%" : 700}
          centered
          bodyStyle={{ padding: "20px" }}
        >
          {mywishes?.length > 0 && (
            <div className="mb-3">
              <Input
                prefix={<SearchOutlined style={{ color: "#94a3b8" }} />}
                placeholder="Search wishes by sender name, occasion or message..."
                value={wishesSearchQuery}
                onChange={e => setWishesSearchQuery(e.target.value)}
                allowClear
                style={{ borderRadius: 12, padding: "8px 14px", border: "1px solid #cbd5e1" }}
              />
            </div>
          )}

          {(() => {
            const q = (wishesSearchQuery || "").toLowerCase();
            const filteredWishes = (mywishes || []).filter(w => {
              const sender = (w.sender_name || "").toLowerCase();
              const occasion = (w.occasion || "").toLowerCase();
              const msg = (w.message || "").toLowerCase();
              return sender.includes(q) || occasion.includes(q) || msg.includes(q);
            });

            if (!mywishes || mywishes.length === 0) {
              return (
                <div style={{ textAlign: "center", padding: "40px 20px", color: "#64748b" }}>
                  <div style={{ fontSize: 44, marginBottom: 10 }}>🎁</div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: "#0f172a" }}>No Wishes Received Yet</div>
                  <div style={{ fontSize: 13, color: "#94a3b8", marginTop: 4 }}>
                    Wishes sent by your teammates for your birthday or work anniversary will appear here!
                  </div>
                </div>
              );
            }

            if (filteredWishes.length === 0) {
              return (
                <div style={{ textAlign: "center", padding: "30px 20px", color: "#64748b" }}>
                  <div style={{ fontSize: 32, marginBottom: 6 }}>🔍</div>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>No matching wishes found for "{wishesSearchQuery}"</div>
                </div>
              );
            }

            return (
              <div className="d-flex flex-column gap-3" style={{ maxHeight: 480, overflowY: "auto", paddingRight: 4 }}>
                {filteredWishes.map((wish, idx) => (
                  <div
                    key={wish.id || idx}
                    style={{
                      background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
                      border: "1.5px solid #fde68a",
                      borderRadius: 14,
                      padding: "14px 16px",
                      boxShadow: "0 4px 12px rgba(217, 119, 6, 0.08)",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <Avatar
                          style={{
                            background: "linear-gradient(135deg, #d97706, #b45309)",
                            color: "#fff",
                            fontWeight: 800,
                          }}
                          size="medium"
                        >
                          {(wish.sender_name || "S")[0].toUpperCase()}
                        </Avatar>
                        <div>
                          <div style={{ fontWeight: 800, fontSize: 14, color: "#0f172a" }}>
                            {wish.sender_name}
                          </div>
                          {wish.created_at && (
                            <div style={{ fontSize: 10.5, color: "#78350f", fontWeight: 600 }}>
                              {dayjs(wish.created_at).format("DD MMM YYYY, hh:mm A")}
                            </div>
                          )}
                        </div>
                      </div>
                      <Tag color="warning" style={{ borderRadius: 10, fontWeight: 800, fontSize: 11, padding: "2px 10px" }}>
                        🎉 {wish.occasion || "Celebration"}
                      </Tag>
                    </div>
                    <div
                      style={{
                        background: "rgba(255, 255, 255, 0.8)",
                        borderRadius: 10,
                        padding: "10px 14px",
                        fontSize: 13,
                        fontStyle: "italic",
                        color: "#1e293b",
                        lineHeight: 1.5,
                        borderLeft: "3px solid #d97706",
                      }}
                    >
                      "{wish.message}"
                    </div>
                  </div>
                ))}
              </div>
            );
          })()}
        </Modal>

        {/* PENDING REQUESTS MODAL */}
        <Modal
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 18 }}>📋</span>
              <span style={{ fontWeight: 900, fontSize: 16, color: "#9a3412" }}>Pending Approval Requests</span>
              <Tag color="orange" style={{ borderRadius: 10, fontWeight: 800, padding: "2px 10px", margin: 0 }}>
                {(teamPendingData?.counts?.leave || 0) + (teamPendingData?.counts?.permission || 0) + (teamPendingData?.counts?.onduty || 0) + (teamPendingData?.counts?.off_day_working || 0)} Total
              </Tag>
            </div>
          }
          open={pendingRequestsModal}
          onCancel={() => setPendingRequestsModal(false)}
          footer={null}
          width={isMobile ? "95%" : 680}
          centered
          destroyOnClose
        >
          {(() => {
            const leaveReqs = teamPendingData?.leave_requests || [];
            const permReqs = teamPendingData?.permission_requests || [];
            const odReqs = teamPendingData?.onduty_requests || [];
            const compReqs = teamPendingData?.off_day_working_requests || [];
            const total = leaveReqs.length + permReqs.length + odReqs.length + compReqs.length;

            if (total === 0) {
              return (
                <div className="py-5 text-center">
                  <div style={{ fontSize: 36, marginBottom: 8 }}>✅</div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: "#0f172a" }}>No Pending Requests</div>
                  <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>All team requests have been processed</div>
                </div>
              );
            }

            const renderRequestRow = (req, type) => {
              const emp = req.employee || {};
              const photoUrl = emp.profile_picture ? (emp.profile_picture.startsWith("http") ? emp.profile_picture : `${backUrl}${emp.profile_picture}`) : null;
              const nameStr = emp.name || emp.full_name || "Employee";
              const codeStr = emp.emp_code || "";
              let typeTag = null;
              let detailStr = "";
              if (type === "leave") {
                typeTag = <Tag color="red" style={{ borderRadius: 8, fontWeight: 800, fontSize: 11 }}>🏖️ Leave</Tag>;
                detailStr = `${req.leave_type || "Leave"} · ${req.start_date || ""} to ${req.end_date || ""}`;
              } else if (type === "permission") {
                typeTag = <Tag color="blue" style={{ borderRadius: 8, fontWeight: 800, fontSize: 11 }}>⏱️ Permission</Tag>;
                detailStr = `${req.date || ""} · ${req.hours_requested || ""} hrs`;
              } else if (type === "onduty") {
                typeTag = <Tag color="purple" style={{ borderRadius: 8, fontWeight: 800, fontSize: 11 }}>💼 On Duty</Tag>;
                detailStr = req.date || (req.start_time ? dayjs(req.start_time).format("DD MMM YYYY") : "");
              } else if (type === "compoff") {
                typeTag = <Tag color="gold" style={{ borderRadius: 8, fontWeight: 800, fontSize: 11 }}>🔄 Off Day Working</Tag>;
                detailStr = req.work_date || "";
              }
              return (
                <div
                  key={`${type}-${req.request_id}`}
                  style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 14, marginBottom: 8 }}
                >
                  <Avatar
                    src={photoUrl || undefined}
                    style={{ background: "linear-gradient(135deg, #f97316, #ea580c)", color: "#fff", fontWeight: 800, flexShrink: 0 }}
                    size={40}
                  >
                    {nameStr[0]?.toUpperCase()}
                  </Avatar>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                      <span style={{ fontWeight: 800, fontSize: 13.5, color: "#0f172a" }}>{nameStr}</span>
                      {codeStr && <span style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>({codeStr})</span>}
                    </div>
                    <div style={{ fontSize: 12, color: "#475569", marginTop: 2 }}>{detailStr}</div>
                    {req.remarks && <div style={{ fontSize: 11.5, color: "#64748b", marginTop: 2, fontStyle: "italic" }}>📝 {req.remarks}</div>}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
                    {typeTag}
                    <Tag color="warning" style={{ borderRadius: 8, fontWeight: 700, fontSize: 10.5, padding: "1px 8px" }}>⏳ Pending</Tag>
                  </div>
                </div>
              );
            };

            return (
              <div style={{ maxHeight: "480px", overflowY: "auto" }}>
                {leaveReqs.length > 0 && (
                  <>
                    <div style={{ fontWeight: 800, fontSize: 12, color: "#ef4444", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: 8, marginTop: 4 }}>🏖️ Leave Requests ({leaveReqs.length})</div>
                    {leaveReqs.map(r => renderRequestRow(r, "leave"))}
                  </>
                )}
                {permReqs.length > 0 && (
                  <>
                    <div style={{ fontWeight: 800, fontSize: 12, color: "#3b82f6", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: 8, marginTop: 8 }}>⏱️ Permission Requests ({permReqs.length})</div>
                    {permReqs.map(r => renderRequestRow(r, "permission"))}
                  </>
                )}
                {odReqs.length > 0 && (
                  <>
                    <div style={{ fontWeight: 800, fontSize: 12, color: "#8b5cf6", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: 8, marginTop: 8 }}>💼 On-Duty Requests ({odReqs.length})</div>
                    {odReqs.map(r => renderRequestRow(r, "onduty"))}
                  </>
                )}
                {compReqs.length > 0 && (
                  <>
                    <div style={{ fontWeight: 800, fontSize: 12, color: "#d97706", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: 8, marginTop: 8 }}>🔄 Off Day Working ({compReqs.length})</div>
                    {compReqs.map(r => renderRequestRow(r, "compoff"))}
                  </>
                )}
              </div>
            );
          })()}
        </Modal>

        {/* TEAM MEMBER CATEGORY DETAIL MODAL */}
        <Modal
          title={
            <div className="d-flex align-items-center justify-content-between pe-4">
              <div className="d-flex align-items-center gap-2">
                <div style={{
                  width: 32,
                  height: 32,
                  borderRadius: 10,
                  background: memberCategoryModal.color ? `${memberCategoryModal.color}15` : "#e0f2fe",
                  border: `1px solid ${memberCategoryModal.color || "#3b82f6"}40`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 16
                }}>
                  👥
                </div>
                <span style={{ color: "#0f172a", fontWeight: 900, fontSize: 16 }}>
                  {memberCategoryModal.title}
                </span>
              </div>
              <Tag color="blue" style={{ borderRadius: 20, fontWeight: 800, padding: "3px 12px", fontSize: 11.5 }}>
                {memberCategoryModal.members?.length || 0} Members
              </Tag>
            </div>
          }
          open={memberCategoryModal.visible}
          onCancel={() => {
            setMemberCategoryModal({ ...memberCategoryModal, visible: false });
            setSearchModalQuery("");
          }}
          footer={null}
          width={isMobile ? "95%" : 680}
          centered
          bodyStyle={{ padding: "20px" }}
        >
          {memberCategoryModal.members?.length > 0 && (
            <div className="mb-3">
              <Input
                prefix={<SearchOutlined style={{ color: "#94a3b8" }} />}
                placeholder="Search employee by name, code or status..."
                value={searchModalQuery}
                onChange={e => setSearchModalQuery(e.target.value)}
                allowClear
                style={{ borderRadius: 12, padding: "9px 16px", border: "1px solid #cbd5e1", boxShadow: "0 2px 6px rgba(0,0,0,0.02)" }}
              />
            </div>
          )}
          {(() => {
            const getMemberCheckInSortValue = (m) => {
              const cin = m.check_in_time || m.check_in_raw || m.check_in || m.first_check_in;
              if (!cin || cin === "-") return 99999999;
              const match = String(cin).match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
              if (match) {
                let hrs = parseInt(match[1], 10);
                const mins = parseInt(match[2], 10);
                const ampm = match[3].toUpperCase();
                if (ampm === "PM" && hrs < 12) hrs += 12;
                if (ampm === "AM" && hrs === 12) hrs = 0;
                return hrs * 60 + mins;
              }
              return 99999999;
            };

            const sortedMembers = [...(memberCategoryModal.members || [])].sort((a, b) => {
              const valA = getMemberCheckInSortValue(a);
              const valB = getMemberCheckInSortValue(b);
              if (valA !== valB) return valA - valB;
              return (a.name || a.full_name || "").localeCompare(b.name || b.full_name || "");
            });

            const query = (searchModalQuery || "").toLowerCase();
            const filteredMembers = sortedMembers.filter(m => {
              const name = (m.name || m.full_name || `${m.first_name || ''} ${m.last_name || ''}`).toLowerCase();
              const code = (m.emp_code || m.employee_code || m.EmployeeCode || "").toLowerCase();
              const leaveType = (m.leave_type || m.status || "").toLowerCase();
              return name.includes(query) || code.includes(query) || leaveType.includes(query);
            });

            if (filteredMembers.length === 0) {
              return (
                <div className="py-5 text-center text-secondary">
                  <div style={{ fontSize: 36, marginBottom: 8 }}>🔍</div>
                  <div style={{ fontWeight: 800, fontSize: 14, color: "#334155" }}>No matching members found</div>
                  <div style={{ fontSize: 12, color: "#94a3b8" }}>Try adjusting your search criteria</div>
                </div>
              );
            }

            return (
              <div className="d-flex flex-column gap-2 py-1" style={{ maxHeight: "460px", overflowY: "auto", paddingRight: 4 }}>
                {filteredMembers.map((member, idx) => {
                  const photoPath = member.profile_picture || member.photo || member.profile_photo || member.avatar;
                  const fullUrl = photoPath ? (photoPath.startsWith("http") ? photoPath : `${backUrl}${photoPath.startsWith('/') ? '' : '/'}${photoPath}`) : UserImg;
                  const nameStr = member.name || member.full_name || `${member.first_name || ''} ${member.last_name || ''}`.trim() || "Employee";
                  const empCodeStr = member.emp_code || member.employee_code || member.EmployeeCode || "-";
                  const timeStr = getMemberDisplayTime(member);
                  const badgeInfo = getLeaveColorAndBadge(member);
                  const isPureAbsent = badgeInfo.label === "Absent" || (!member.leave_type && (member.status === "Absent" || badgeInfo.tagColor === "red"));

                  return (
                    <div
                      key={member.id || idx}
                      className="p-3 mb-1 d-flex align-items-center justify-content-between"
                      style={{
                        background: "#f8fafc",
                        borderRadius: 14,
                        border: "1px solid #e2e8f0",
                        borderLeft: `4.5px solid ${badgeInfo.color || "#3b82f6"}`,
                        transition: "all 0.2s ease",
                        cursor: "pointer",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.02)"
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.background = "#ffffff";
                        e.currentTarget.style.borderColor = "#cbd5e1";
                        e.currentTarget.style.boxShadow = "0 6px 18px rgba(15,23,42,0.08)";
                        e.currentTarget.style.transform = "translateY(-1.5px)";
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.background = "#f8fafc";
                        e.currentTarget.style.borderColor = "#e2e8f0";
                        e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.02)";
                        e.currentTarget.style.transform = "translateY(0)";
                      }}
                      onClick={() => {
                        setSelectedLogMember(member);
                        setLogModalVisible(true);
                      }}
                    >
                      {/* AVATAR + EMP CODE & NAME */}
                      <div className="d-flex align-items-center gap-3" style={{ minWidth: 0, flex: 1 }}>
                        <img
                          src={fullUrl}
                          alt={nameStr}
                          onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                          style={{ width: 38, height: 38, borderRadius: "50%", objectFit: "cover", border: "2px solid #ffffff", boxShadow: "0 2px 6px rgba(0,0,0,0.1)", flexShrink: 0 }}
                        />
                        <div style={{ minWidth: 0 }}>
                          <div style={{ fontWeight: 800, fontSize: 14, color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {nameStr}
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 2 }}>
                            <span style={{ fontSize: 11, fontWeight: 800, color: "#2563eb", background: "#eff6ff", border: "1px solid #bfdbfe", padding: "1px 7px", borderRadius: 6 }}>
                              ID: {empCodeStr}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* TIME & STATUS */}
                      <div className="d-flex align-items-center gap-3 flex-shrink-0">
                        <div style={{ fontSize: 12.5, fontWeight: 700, color: "#334155", background: "#ffffff", border: "1px solid #e2e8f0", padding: "4px 10px", borderRadius: 10, display: "flex", alignItems: "center", gap: 5 }}>
                          <ClockCircleOutlined style={{ fontSize: 13, color: "#2563eb" }} />
                          <span>{timeStr}</span>
                        </div>

                        <div className="d-flex flex-column align-items-end gap-1">
                          <Tag color={badgeInfo.tagColor} style={{ borderRadius: 10, fontWeight: 800, fontSize: 11.5, padding: "4px 10px", margin: 0, border: `1px solid ${badgeInfo.color}30` }}>
                            {badgeInfo.icon} {badgeInfo.label}
                          </Tag>
                          {isPureAbsent && (
                            <span style={{ fontSize: 10.5, fontWeight: 700, color: "#dc2626" }}>
                              ⚠️ No Leaves updated in Application
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </Modal>
      </div>
    );
  };

  // Render selected page content
  const renderContent = () => {
    switch (selectedMenu) {
      case "home":
        return renderHome();
      case "applyMRF":
        return <CreateMrf onSubmitSuccess={() => setSelectedMenu("viewRequisitions")} />;
      case "viewRequisitions":
        return <HodViewReq />;
      case "teamRequisitions":
        return <ViewTeam />;
      case "leaveRequests":
        return <Teamleaves />;
      case "compoffRequests":
        return <TeamCompoff />;
      case "permissionRequests":
        return <TeamPermissions />;
      case "holidays":
        return <Holidays />;
      case "offDayDutyApply":
        return <OffDay />;
      case "permissions":
        return <Permission />;
      case "leaves":
        return <Leaves />;
      case "interview":
        return <InterviewPage />;
      case "teamattendance":
        return <TeamAttendance />;
      case "myattendance":
        return <ViewEmpAttendance />;
      case "rfc":
        return <Rfc />;
      case "teamemployement":
        return <ProbationReview />;
      case "otapproval":
        return <OtApprovals is_employee_view={true} />;
      case "showselfassessments":
        return <TeamAssessment />;
      case "pipapprovals":
        return <PipApprovals />;
      case "resignationRequests":
        return <ResignationRequests />;
      case "overall":
        return <OverallEmployees />;
      case "signatureUpdation":
        return <SignatureUpdation />
      case "orgchart":
        return <OrgChart />
      case "onduty":
        return <PastOnduty />
      case "resignation":
        return <Resignation />
      case "NocClearence":
        return <ListNoc />
      case "exitInterview":
        return <ExitInterview />
      case "teamMembers":
        return <TeamMembers />
      case "applyOnduty":
        return <OnDutyAttendance />
      case "appliedOnDuty":
        return <AppliedOnduty />
      case "payslip":
        return <PaySlip />;
      case "noticeperiod":
        return <NoticeEmployees />
      case "profile":
        return <EmployeeProfile onBack={handleBack} />
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      <DashboardHeader
        dashboardMode={dashboardMode}
        setDashboardMode={setDashboardMode}
        showDashboardSwitch={true}
      />

      {/* Mobile top bar */}
      {isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "10px 20px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px", color: "#0e497b" }} />}
            onClick={() => setDrawerVisible(true)}
          />
        </div>
      )}
      <Layout style={{ minHeight: "calc(100vh - 64px)", background: "linear-gradient(180deg, #f0f4f8 0%, #e8edf5 100%)" }}>
        {/* Desktop Sidebar */}
        {!isMobile && (
          <Sider
            width={260}
            collapsible
            collapsed={collapsed}
            onCollapse={setCollapsed}
            theme="light"
            style={{
              background: "#fff",
              borderRight: "1px solid #e2e8f0",
              boxShadow: "2px 0 8px rgba(15,23,42,0.04)",
              position: "fixed",
              left: 0,
              bottom: 0,
              zIndex: 900,
              overflowY: "auto",
              top: 125,
            }}
          >
            <style>{`
              .ant-menu { background: #fff !important; border-right: none !important; padding: 10px 8px !important; }
              .ant-menu-item, .ant-menu-submenu-title { font-weight: 650 !important; font-size: 13.5px !important; color: #334155 !important; border-radius: 12px !important; margin-bottom: 5px !important; transition: background-color 0.15s ease, transform 0.15s ease !important; }
              .ant-menu-item:hover, .ant-menu-submenu-title:hover { background-color: rgba(14,73,123,0.06) !important; color: #0e497b !important; transform: translateX(3px) !important; }
              .ant-menu-item-selected { background: linear-gradient(135deg, #0e497b 0%, #1d4ed8 100%) !important; color: #ffffff !important; font-weight: 800 !important; border-left: 3.5px solid #38bdf8 !important; box-shadow: 0 4px 16px rgba(14,73,123,0.3) !important; transform: translateX(3px) !important; transition: none !important; }
              .ant-menu-item-selected, .ant-menu-item-selected *, .ant-menu-item-selected .ant-menu-title-content, .ant-menu-item-selected .anticon { color: #ffffff !important; transition: none !important; }
              .ant-menu-submenu-open > .ant-menu-submenu-title { color: #0e497b !important; font-weight: 800 !important; background-color: rgba(14,73,123,0.07) !important; }
            `}</style>
            <br />

            <Menu
              mode="inline"
              selectedKeys={[selectedMenu]}
              onClick={({ key }) => setSelectedMenu(key)}
              style={{ height: "100%", borderRight: 0, background: "#fff", fontWeight: "bold" }}
              items={menuItems}
            />
          </Sider>
        )}
        {/* Mobile Drawer Sidebar */}
        <Drawer
          title="Navigation"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedMenu]}
            onClick={({ key }) => {
              setSelectedMenu(key);
              setDrawerVisible(false);
            }}
            style={{ height: "100%", borderRight: 0, background: "#fff", fontWeight: "bold" }}
            items={menuItems}
          />
        </Drawer>
        {/* Main Content */}
        <Layout style={{
          marginLeft: isMobile ? 0 : (collapsed ? 80 : 260),
          transition: "margin-left 0.2s ease-in-out",
          padding: isMobile ? "12px" : "20px 24px",
          background: "linear-gradient(180deg, #f0f4f8 0%, #e8edf5 100%)",
          minHeight: "calc(100vh - 64px)",
          minWidth: 0,
          width: "100%",
        }}>
          <Content style={{ background: "transparent", minWidth: 0, width: "100%" }}>{renderContent()}</Content>
        </Layout>
      </Layout>
      {/* DETAILED ATTENDANCE PUNCH LOG MODAL FOR SINGLE MEMBER */}
      {logModalVisible && selectedLogMember && (
        <Modal
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 20 }}>⏱️</span>
              <div>
                <div style={{ fontWeight: 800, fontSize: 16, color: "#0f172a" }}>
                  {selectedLogMember.name || selectedLogMember.full_name || "Employee"}'s Attendance Details
                </div>
                <div style={{ fontSize: 12, color: "#64748b", fontWeight: 600 }}>
                  Date: {dayjs().format("DD MMM YYYY")}
                </div>
              </div>
            </div>
          }
          open={logModalVisible}
          onCancel={() => { setLogModalVisible(false); setSelectedLogMember(null); }}
          footer={null}
          width={740}
          centered
          style={{ borderRadius: 16, overflow: "hidden" }}
        >
          {/* Employee Profile Header Banner */}
          <div style={{
            background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
            borderRadius: 14,
            border: "1px solid #e2e8f0",
            padding: "14px 16px",
            marginBottom: 16
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
              <img
                src={
                  selectedLogMember.profile_picture || selectedLogMember.photo
                    ? (selectedLogMember.profile_picture || selectedLogMember.photo).startsWith("http")
                      ? (selectedLogMember.profile_picture || selectedLogMember.photo)
                      : `${backUrl}${(selectedLogMember.profile_picture || selectedLogMember.photo).startsWith('/') ? '' : '/'}${selectedLogMember.profile_picture || selectedLogMember.photo}`
                    : UserImg
                }
                alt="Profile"
                onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                style={{ width: 52, height: 52, borderRadius: "50%", objectFit: "cover", border: "2px solid #fff", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
              />
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ fontWeight: 800, fontSize: 15, color: "#0f172a", display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                  <span>{selectedLogMember.name || selectedLogMember.full_name || "Employee"}</span>
                  {(selectedLogMember.emp_code || selectedLogMember.EmployeeCode) && (
                    <Tag color="blue" style={{ borderRadius: 6, fontWeight: 700, margin: 0 }}>
                      {selectedLogMember.emp_code || selectedLogMember.EmployeeCode}
                    </Tag>
                  )}
                </div>
                {selectedLogMember.designation && (
                  <div style={{ fontSize: 12.5, fontWeight: 700, color: "#334155", marginTop: 2 }}>
                    💼 {selectedLogMember.designation}
                  </div>
                )}
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6, flexWrap: "wrap" }}>
                  {selectedLogMember.department && (
                    <span style={{ fontSize: 11, fontWeight: 700, color: "#1d4ed8", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 20, padding: "2px 10px" }}>
                      🏢 Dept: {selectedLogMember.department}
                    </span>
                  )}
                  {selectedLogMember.organisation && (
                    <span style={{ fontSize: 11, fontWeight: 700, color: "#065f46", background: "#ecfdf5", border: "1px solid #a7f3d0", borderRadius: 20, padding: "2px 10px" }}>
                      🏗️ Org: {selectedLogMember.organisation}
                    </span>
                  )}
                  {(() => {
                    const badgeInfo = getLeaveColorAndBadge(selectedLogMember);
                    const isPureAbsent = badgeInfo.label === "Absent" || (!selectedLogMember.leave_type && (selectedLogMember.status === "Absent" || badgeInfo.tagColor === "red"));
                    return (
                      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                        <Tag color={badgeInfo.tagColor} style={{ borderRadius: 20, fontWeight: 800, fontSize: 11, padding: "2px 10px", margin: 0 }}>
                          {badgeInfo.icon} {badgeInfo.label}
                        </Tag>
                        {isPureAbsent && (
                          <span style={{ fontSize: 11, fontWeight: 700, color: "#dc2626" }}>
                            ⚠️ Leave Not Updated — No Leaves updated in Application
                          </span>
                        )}
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>

          <ImproperLog
            record={{
              Date: dayjs().format("YYYY-MM-DD"),
              Status: selectedLogMember.status,
              AttendanceStatus: selectedLogMember.status,
              LeaveType: selectedLogMember.leave_type,
              StatusMessage: selectedLogMember.remarks,
              Emp_id: selectedLogMember.id,
              EmployeeCode: selectedLogMember.emp_code || selectedLogMember.EmployeeCode
            }}
            employee={selectedLogMember}
          />
        </Modal>
      )}
      <Footer style={{ background: "#fff" }} />
    </Layout>
  );
}